/* 🤖 this file was generated by svg-to-ts */
export const iconGriddyAlertCircle: {
  name: 'griddy-alert-circle';
  data: string;
} = {
  name: 'griddy-alert-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 22C6.485 22 2 17.515 2 12S6.485 2 12 2s10 4.485 10 10-4.485 10-10 10m0-18.5c-4.685 0-8.5 3.815-8.5 8.5s3.815 8.5 8.5 8.5 8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5m.75 10V8h-1.5v5.5zM13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyAlertTriangle: {
  name: 'griddy-alert-triangle';
  data: string;
} = {
  name: 'griddy-alert-triangle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.86 21c-.45 0-.855-.235-1.08-.625a1.23 1.23 0 0 1 0-1.25L10.915 3.14a1.25 1.25 0 0 1 2.17 0l9.14 15.99c.225.39.22.86 0 1.25-.225.39-.63.625-1.08.625L21.14 21zm.435-1.5H20.71L12 4.26 3.29 19.5zm9.455-5V9h-1.5v5.5zM13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyAnalyzeVoice: {
  name: 'griddy-analyze-voice';
  data: string;
} = {
  name: 'griddy-analyze-voice',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M17.75 2h-1.5c0 1.79-1.46 3.25-3.25 3.25v1.5c1.79 0 3.25 1.46 3.25 3.25h1.5c0-1.79 1.46-3.25 3.25-3.25v-1.5c-1.79 0-3.25-1.46-3.25-3.25M17 7.45A4.8 4.8 0 0 0 15.55 6 4.8 4.8 0 0 0 17 4.55c.37.58.865 1.075 1.45 1.45-.58.37-1.075.865-1.45 1.45M12 17.5a6.48 6.48 0 0 1-6.005-4.01l-1.385.575a7.98 7.98 0 0 0 6.645 4.9v1.54H7v1.5h10v-1.5h-4.25v-1.54a7.99 7.99 0 0 0 6.645-4.9l-1.385-.575a6.49 6.49 0 0 1-6.005 4.01zm4.975-6A5.003 5.003 0 0 1 12 16c-2.755 0-5-2.245-5-5V7c0-2.755 2.245-5 5-5v1.5c-1.93 0-3.5 1.57-3.5 3.5v4c0 1.93 1.57 3.5 3.5 3.5a3.5 3.5 0 0 0 3.46-3z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyAnnouncementAlt02: {
  name: 'griddy-announcement-alt-02';
  data: string;
} = {
  name: 'griddy-announcement-alt-02',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M22 11.25a4.25 4.25 0 0 0-3-4.06V3.705a1.247 1.247 0 0 0-1.96-1.025l-5.525 3.825H5.75A2.755 2.755 0 0 0 3 9.255v3.5a2.755 2.755 0 0 0 2.75 2.75H6v4.75c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25v-4.75h.515l5.525 3.825A1.248 1.248 0 0 0 19 18.305V15.32a4.26 4.26 0 0 0 3-4.06zm-4.5 6.57L11.985 14H9.5v6h-2v-6H5.75c-.69 0-1.25-.56-1.25-1.25v-3.5C4.5 8.56 5.06 8 5.75 8h6.235L17.5 4.18zm1.5-4.125V8.8c.89.455 1.5 1.38 1.5 2.445s-.61 1.99-1.5 2.445z"/></svg>`,
};
export const iconGriddyArrowElbowDownRight: {
  name: 'griddy-arrow-elbow-down-right';
  data: string;
} = {
  name: 'griddy-arrow-elbow-down-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="m13.5 9.5 4.895 4.895a.5.5 0 0 1 0 .705L13.5 19.995"/><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="M18.5 14.75H8.75a2 2 0 0 1-2-2V4"/></svg>`,
};
export const iconGriddyArrowLeft: {
  name: 'griddy-arrow-left';
  data: string;
} = {
  name: 'griddy-arrow-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M21 11.25H5.31l5.22-5.22-1.06-1.06-6.145 6.145a1.26 1.26 0 0 0 0 1.77L9.47 19.03l1.06-1.06-5.22-5.22H21z"/></svg>`,
};
export const iconGriddyArrowRight: {
  name: 'griddy-arrow-right';
  data: string;
} = {
  name: 'griddy-arrow-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M20.675 11.115 14.53 4.97l-1.06 1.06 5.22 5.22H3v1.5h15.69l-5.22 5.22 1.06 1.06 6.145-6.145a1.26 1.26 0 0 0 0-1.77"/></svg>`,
};
export const iconGriddyArrowUp: {
  name: 'griddy-arrow-up';
  data: string;
} = {
  name: 'griddy-arrow-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="m19.03 9.47-6.145-6.145a1.26 1.26 0 0 0-1.77 0L4.97 9.47l1.06 1.06 5.22-5.22V21h1.5V5.31l5.22 5.22z"/></svg>`,
};
export const iconGriddyAttachmentAlt01: {
  name: 'griddy-attachment-alt-01';
  data: string;
} = {
  name: 'griddy-attachment-alt-01',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M12.005 22c-.11 0-.225 0-.335-.01C9.05 21.82 7 19.565 7 16.855v-9.71c0-2.71 2.05-4.965 4.67-5.135 1.4-.095 2.73.385 3.75 1.34A5.01 5.01 0 0 1 17 7v1h-1.5V7a3.48 3.48 0 0 0-1.105-2.555c-.715-.67-1.64-1-2.625-.94-1.83.12-3.265 1.715-3.265 3.64v9.71c0 1.92 1.435 3.52 3.265 3.64.98.065 1.915-.27 2.625-.94A3.46 3.46 0 0 0 15.5 17v-4.25c0-.965-.785-1.75-1.75-1.75S12 11.785 12 12.75v4.5h-1.5v-4.5c0-1.79 1.46-3.25 3.25-3.25S17 10.96 17 12.75V17a5.03 5.03 0 0 1-1.58 3.65A4.94 4.94 0 0 1 12.005 22"/></svg>`,
};
export const iconGriddyAttachment: {
  name: 'griddy-attachment';
  data: string;
} = {
  name: 'griddy-attachment',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M7.25 22.095c-1.37 0-2.74-.52-3.78-1.565a5.35 5.35 0 0 1 0-7.56l9.5-9.5a5.35 5.35 0 0 1 7.56 0 5.35 5.35 0 0 1 0 7.56l-1.25 1.25-1.06-1.06 1.25-1.25a3.85 3.85 0 0 0 0-5.44 3.85 3.85 0 0 0-5.44 0l-9.5 9.5a3.85 3.85 0 0 0 0 5.44 3.85 3.85 0 0 0 5.44 0l4.75-4.75c.81-.81.81-2.13 0-2.94s-2.13-.81-2.94 0l-5 5-1.06-1.06 5-5a3.58 3.58 0 0 1 5.06 0 3.58 3.58 0 0 1 0 5.06l-4.75 4.75a5.33 5.33 0 0 1-3.78 1.565"/></svg>`,
};
export const iconGriddyBookOpen: {
  name: 'griddy-book-open';
  data: string;
} = {
  name: 'griddy-book-open',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M15 4a3.75 3.75 0 0 0-3 1.51A3.75 3.75 0 0 0 9 4H2v16h7.5c.69 0 1.25.56 1.25 1.25h2.5c0-.69.56-1.25 1.25-1.25H22V4zm-3.75 15.13a2.73 2.73 0 0 0-1.75-.63h-6v-13H9c1.24 0 2.25 1.01 2.25 2.25zm9.25-.63h-6c-.665 0-1.275.235-1.75.63V7.75c0-1.24 1.01-2.25 2.25-2.25h5.5z"/></svg>`,
};
export const iconGriddyBook: {
  name: 'griddy-book';
  data: string;
} = {
  name: 'griddy-book',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.75 3.5c-.69 0-1.25.56-1.25 1.25V16.8c.375-.192.8-.3 1.25-.3H18.5v-13zM18.5 18H6.75a1.25 1.25 0 1 0 0 2.5H18.5zM4 19.25V4.75A2.75 2.75 0 0 1 6.75 2H20v20H6.75A2.75 2.75 0 0 1 4 19.25" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyBriefcaseAlt: {
  name: 'griddy-briefcase-alt';
  data: string;
} = {
  name: 'griddy-briefcase-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M19.25 6.5H16v-.75A2.755 2.755 0 0 0 13.25 3h-2.5A2.755 2.755 0 0 0 8 5.75v.75H4.75A2.755 2.755 0 0 0 2 9.25v9A2.755 2.755 0 0 0 4.75 21h14.5A2.755 2.755 0 0 0 22 18.25v-9a2.755 2.755 0 0 0-2.75-2.75M9.5 5.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v.75h-5zm11 12.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-9C3.5 8.56 4.06 8 4.75 8h14.5c.69 0 1.25.56 1.25 1.25z"/></svg>`,
};
export const iconGriddyCalendarCheck: {
  name: 'griddy-calendar-check';
  data: string;
} = {
  name: 'griddy-calendar-check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.5 3h.75A2.755 2.755 0 0 1 21 5.75v12.5A2.755 2.755 0 0 1 18.25 21H5.75A2.755 2.755 0 0 1 3 18.25V5.75A2.755 2.755 0 0 1 5.75 3h.75V2H8v1h8V2h1.5zm-11 1.5h-.75c-.69 0-1.25.56-1.25 1.25v1.745h15V5.75c0-.69-.56-1.25-1.25-1.25h-.75V6H16V4.5H8V6H6.5zm-.75 15h12.5c.69 0 1.25-.56 1.25-1.25V8.995h-15v9.255c0 .69.56 1.25 1.25 1.25m3.03-5.78 1.97 1.97 4.97-4.97 1.06 1.06-5.145 5.145a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L7.72 14.78z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCalendarDate: {
  name: 'griddy-calendar-date';
  data: string;
} = {
  name: 'griddy-calendar-date',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M17.5 3h.75A2.755 2.755 0 0 1 21 5.75v12.5A2.755 2.755 0 0 1 18.25 21H5.75A2.755 2.755 0 0 1 3 18.25V5.75A2.755 2.755 0 0 1 5.75 3h.75V2H8v1h8V2h1.5zm-11 1.5h-.75c-.69 0-1.25.56-1.25 1.25V7.5h15V5.75c0-.69-.56-1.25-1.25-1.25h-.75V6H16V4.5H8V6H6.5zm-.75 15h12.5c.69 0 1.25-.56 1.25-1.25V9h-15v9.25c0 .69.56 1.25 1.25 1.25m5.5-8.5h1.5v5H14v1.5h-4V16h1.25v-2.5H10V12h1.25z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCalendarTime: {
  name: 'griddy-calendar-time';
  data: string;
} = {
  name: 'griddy-calendar-time',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.5 4.5V6H8V4.5h8V6h1.5V4.5h.75c.69 0 1.25.56 1.25 1.25V7.5H21V5.75A2.75 2.75 0 0 0 18.25 3h-.75V2H16v1H8V2H6.5v1h-.75A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21H9v-1.5H5.75c-.69 0-1.25-.56-1.25-1.25V9H11V7.5H4.5V5.75c0-.69.56-1.25 1.25-1.25zM11 15.25a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0m5.25-6.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5m.75 3v3.44l1.78 1.78-1.06 1.06-2.22-2.22V11.5z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCalendar: {
  name: 'griddy-calendar';
  data: string;
} = {
  name: 'griddy-calendar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M18.25 3h-.75V2H16v1H8V2H6.5v1h-.75A2.755 2.755 0 0 0 3 5.75v12.5A2.755 2.755 0 0 0 5.75 21h12.5A2.755 2.755 0 0 0 21 18.25V5.75A2.755 2.755 0 0 0 18.25 3M5.75 4.5h.75V6H8V4.5h8V6h1.5V4.5h.75c.69 0 1.25.56 1.25 1.25V7.5h-15V5.75c0-.69.56-1.25 1.25-1.25m12.5 15H5.75c-.69 0-1.25-.56-1.25-1.25V9h15v9.25c0 .69-.56 1.25-1.25 1.25"/></svg>`,
};
export const iconGriddyChartLineData: {
  name: 'griddy-chart-line-data';
  data: string;
} = {
  name: 'griddy-chart-line-data',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M4.5 18.25v-2.19l4.285-4.285c.295.14.62.225.965.225s.67-.085.965-.225l1.01 1.01c-.14.295-.225.62-.225.965 0 1.24 1.01 2.25 2.25 2.25S16 14.99 16 13.75c0-.345-.085-.67-.225-.965l2.51-2.51c.295.14.62.225.965.225 1.24 0 2.25-1.01 2.25-2.25S20.49 6 19.25 6 17 7.01 17 8.25c0 .345.085.67.225.965l-2.51 2.51a2.24 2.24 0 0 0-.965-.225c-.345 0-.67.085-.965.225l-1.01-1.01c.14-.295.225-.62.225-.965 0-1.24-1.01-2.25-2.25-2.25S7.5 8.51 7.5 9.75c0 .345.085.67.225.965L4.5 13.94V3H3v15.25A2.755 2.755 0 0 0 5.75 21H21v-1.5H5.75c-.69 0-1.25-.56-1.25-1.25M19.25 7.5a.749.749 0 1 1 0 1.5.749.749 0 1 1 0-1.5m-4.75 6.25a.749.749 0 1 1-1.5 0 .749.749 0 1 1 1.5 0M9.75 9a.749.749 0 1 1 0 1.5.749.749 0 1 1 0-1.5"/></svg>`,
};
export const iconGriddyChartLineSmooth: {
  name: 'griddy-chart-line-smooth';
  data: string;
} = {
  name: 'griddy-chart-line-smooth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M5.75 19.5c-.69 0-1.25-.56-1.25-1.25v-.34c1.11-2.535 3.455-6.41 5.25-6.41.895 0 1.425.485 2.22 1.28s1.72 1.72 3.28 1.72c3.5 0 5.69-6.45 5.71-6.515l-1.425-.475c-.575 1.72-2.45 5.485-4.29 5.485-.895 0-1.425-.485-2.22-1.28s-1.72-1.72-3.28-1.72c-2.08 0-4 2.515-5.25 4.635V3h-1.5v15.25A2.755 2.755 0 0 0 5.745 21h15.25v-1.5z"/></svg>`,
};
export const iconGriddyChatBubbleText: {
  name: 'griddy-chat-bubble-text';
  data: string;
} = {
  name: 'griddy-chat-bubble-text',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M6.77 21.7c.155.065.32.095.48.095l.005-.005c.32 0 .64-.125.88-.365L11.56 18h7.69A2.755 2.755 0 0 0 22 15.25v-9.5A2.755 2.755 0 0 0 19.25 3H4.75A2.755 2.755 0 0 0 2 5.75v9.5A2.755 2.755 0 0 0 4.75 18H6v2.545c0 .51.3.96.77 1.155M3.5 5.75c0-.69.56-1.25 1.25-1.25h14.5c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25h-8.31L7.5 19.94V16.5H4.75c-.69 0-1.25-.56-1.25-1.25zM17.5 8h-11v1.5h11zm-4 3.5h-7V13h7z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCheckCircleAlt01: {
  name: 'griddy-check-circle-alt-01';
  data: string;
} = {
  name: 'griddy-check-circle-alt-01',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 12c0-1.13-.23-2.21-.63-3.195h.005l1.13-1.13C21.635 8.985 22 10.45 22 12c0 5.515-4.485 10-10 10S2 17.515 2 12 6.485 2 12 2a9.96 9.96 0 0 1 7.28 3.156l.94-.941 1.06 1.06-9.895 9.9a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L6.72 12.28l1.06-1.06 2.72 2.72 7.715-7.72A8.47 8.47 0 0 0 12 3.5c-4.685 0-8.5 3.815-8.5 8.5s3.815 8.5 8.5 8.5 8.5-3.815 8.5-8.5" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCheckCircle: {
  name: 'griddy-check-circle';
  data: string;
} = {
  name: 'griddy-check-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2 12c0 5.515 4.485 10 10 10s10-4.485 10-10S17.515 2 12 2 2 6.485 2 12m1.5 0c0-4.685 3.815-8.5 8.5-8.5s8.5 3.815 8.5 8.5-3.815 8.5-8.5 8.5-8.5-3.815-8.5-8.5m6.115 3.175c.245.245.565.365.885.365s.64-.12.885-.365L17.28 9.28l-1.06-1.06-5.72 5.72-2.22-2.22-1.06 1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCheck: {
  name: 'griddy-check';
  data: string;
} = {
  name: 'griddy-check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M8.75 18.29c-.32 0-.64-.12-.885-.365l-4.645-4.65 1.06-1.06 4.47 4.47 10.97-10.97 1.06 1.06L9.635 17.92a1.25 1.25 0 0 1-.885.365z"/></svg>`,
};
export const iconGriddyCheckbox: {
  name: 'griddy-checkbox';
  data: string;
} = {
  name: 'griddy-checkbox',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.75 3A2.75 2.75 0 0 0 3 5.75v12.5A2.75 2.75 0 0 0 5.75 21h12.5A2.75 2.75 0 0 0 21 18.25V5.75A2.75 2.75 0 0 0 18.25 3zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25zm11.72 2.465-5.72 5.72-2.22-2.22-1.06 1.06 2.396 2.397a1.25 1.25 0 0 0 1.768 0l5.896-5.897z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyChevronDown: {
  name: 'griddy-chevron-down';
  data: string;
} = {
  name: 'griddy-chevron-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M12 16.54c-.32 0-.64-.12-.885-.365L3.97 9.03l1.06-1.06L12 14.94l6.97-6.97 1.06 1.06-7.145 7.145a1.25 1.25 0 0 1-.885.365"/></svg>`,
};
export const iconGriddyChevronLeft: {
  name: 'griddy-chevron-left';
  data: string;
} = {
  name: 'griddy-chevron-left',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="m14.97 20.03-7.145-7.145a1.26 1.26 0 0 1 0-1.77L14.97 3.97l1.06 1.06L9.06 12l6.97 6.97z"/></svg>`,
};
export const iconGriddyChevronRight: {
  name: 'griddy-chevron-right';
  data: string;
} = {
  name: 'griddy-chevron-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="m9.03 20.03-1.06-1.06L14.94 12 7.97 5.03l1.06-1.06 7.145 7.145c.485.485.485 1.28 0 1.77z"/></svg>`,
};
export const iconGriddyChevronUp: {
  name: 'griddy-chevron-up';
  data: string;
} = {
  name: 'griddy-chevron-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M18.97 16.03 12 9.06l-6.97 6.97-1.06-1.06 7.145-7.145a1.26 1.26 0 0 1 1.77 0l7.145 7.145z"/></svg>`,
};
export const iconGriddyCircleDashed: {
  name: 'griddy-circle-dashed';
  data: string;
} = {
  name: 'griddy-circle-dashed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25"><path fill="currentColor" d="M13.527 22.387c-.498.076-1.012.113-1.528.113q-.775 0-1.522-.113l.225-1.484Q11.335 21 12 21c.444 0 .882-.033 1.303-.097zm4.737-2.092a10 10 0 0 1-2.65 1.53l-.54-1.4a8.4 8.4 0 0 0 2.25-1.3zm-11.588-1.17a8.5 8.5 0 0 0 2.25 1.3l-.541 1.4a10 10 0 0 1-2.649-1.53zm-2.6-3.55c.315.82.756 1.573 1.299 2.25l-1.169.94a10 10 0 0 1-1.53-2.65zm17.248.541a10 10 0 0 1-1.53 2.649l-1.169-.94a8.5 8.5 0 0 0 1.3-2.25zM3.597 11.203a8.676 8.676 0 0 0 0 2.599l-1.484.226A10 10 0 0 1 2 12.5q0-.774.113-1.523zm18.289-.23c.076.498.113 1.011.113 1.527a10 10 0 0 1-.113 1.523l-1.484-.226q.096-.632.097-1.297 0-.668-.097-1.302zM5.375 7.175a8.5 8.5 0 0 0-1.3 2.25l-1.4-.541c.374-.963.893-1.855 1.53-2.649zm14.42-.94a10 10 0 0 1 1.53 2.65l-1.4.54a8.4 8.4 0 0 0-1.3-2.25zm-10.87-1.66a8.4 8.4 0 0 0-2.25 1.3l-.939-1.17a10 10 0 0 1 2.65-1.53zm6.691-1.4c.963.374 1.855.893 2.649 1.53l-.939 1.17a8.5 8.5 0 0 0-2.252-1.3zM12 2.5q.776 0 1.523.113l-.225 1.484a8.677 8.677 0 0 0-2.6 0l-.225-1.484A10 10 0 0 1 12 2.5"/></svg>`,
};
export const iconGriddyClipboardList: {
  name: 'griddy-clipboard-list';
  data: string;
} = {
  name: 'griddy-clipboard-list',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17 3.5V2H7v1.5H4V22h16V3.5zm-8.5 0h7v.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25zm10 17h-13V5h1.605c.33 1.15 1.385 2 2.645 2h4.5c1.255 0 2.315-.85 2.645-2H18.5zm-2-7.5H11v1.5h5.5zm-9 1.5V13h2v1.5zm9 2H11V18h5.5zm-9 1.5v-1.5h2V18zm9-8.5H11V11h5.5zm-9 1.5V9.5h2V11z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCloseCircle: {
  name: 'griddy-close-circle';
  data: string;
} = {
  name: 'griddy-close-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m8.5-1.06 3.22-3.22 1.06 1.06L13.06 12l3.22 3.22-1.06 1.06L12 13.06l-3.22 3.22-1.06-1.06L10.94 12 7.72 8.78l1.06-1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyClose: {
  name: 'griddy-close';
  data: string;
} = {
  name: 'griddy-close',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="m20.28 4.78-1.06-1.06L12 10.94 4.78 3.72 3.72 4.78 10.94 12l-7.22 7.22 1.06 1.06L12 13.06l7.22 7.22 1.06-1.06L13.06 12z"/></svg>`,
};
export const iconGriddyCode: {
  name: 'griddy-code';
  data: string;
} = {
  name: 'griddy-code',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="m15.716 3.236-6.005 18-1.423-.474 6.005-18zM8.03 7.031l-4.97 4.971 4.97 4.97-1.06 1.06-5.145-5.145a1.26 1.26 0 0 1 0-1.77L6.97 5.972zm14.145 4.086c.485.485.485 1.28 0 1.77L17.03 18.03l-1.06-1.06 4.97-4.969-4.97-4.97 1.06-1.06z"/></svg>`,
};
export const iconGriddyConsole: {
  name: 'griddy-console';
  data: string;
} = {
  name: 'griddy-console',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M18.25 3H5.75A2.755 2.755 0 0 0 3 5.75v12.5A2.755 2.755 0 0 0 5.75 21h12.5A2.755 2.755 0 0 0 21 18.25V5.75A2.755 2.755 0 0 0 18.25 3M5.75 4.5h12.5c.69 0 1.25.56 1.25 1.25V7.5h-15V5.75c0-.69.56-1.25 1.25-1.25M19.5 18.25c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25V9h15zM7.78 10.72l-1.06 1.06 2.47 2.47-2.47 2.47 1.06 1.06 2.645-2.645a1.26 1.26 0 0 0 0-1.77zM12 16h5v1.5h-5z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCopy: {
  name: 'griddy-copy';
  data: string;
} = {
  name: 'griddy-copy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7.25 18h12.5c.69 0 1.25-.56 1.25-1.25V4.25C21 3.56 20.44 3 19.75 3H7.25C6.56 3 6 3.56 6 4.25v12.5c0 .69.56 1.25 1.25 1.25m12.25-1.5h-12v-12h12zM5.75 21H18v-1.5H5.75c-.69 0-1.25-.56-1.25-1.25V6H3v12.25A2.755 2.755 0 0 0 5.75 21" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCreditCard: {
  name: 'griddy-credit-card';
  data: string;
} = {
  name: 'griddy-credit-card',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M4.75 4h14.5A2.755 2.755 0 0 1 22 6.75v10.5A2.755 2.755 0 0 1 19.25 20H4.75A2.755 2.755 0 0 1 2 17.25V6.75A2.755 2.755 0 0 1 4.75 4m14.5 14.5c.69 0 1.25-.56 1.25-1.25V10.5h-17v6.75c0 .69.56 1.25 1.25 1.25zM3.5 8.5h17V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25zm2 6.5h6v1.5h-6z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCurrencyExchange: {
  name: 'griddy-currency-exchange';
  data: string;
} = {
  name: 'griddy-currency-exchange',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M12 2c-2.42 0-4.705.86-6.5 2.4V2.5H4v4.495h4.5v-1.5H6.54A8.43 8.43 0 0 1 12 3.5c4.685 0 8.5 3.815 8.5 8.5 0 .945-.155 1.875-.46 2.76l1.42.485c.36-1.045.54-2.135.54-3.25 0-5.515-4.485-10-10-10zm-.75 3.5v1.495h-.5A2.755 2.755 0 0 0 8 9.745V10a2.755 2.755 0 0 0 2.75 2.75h2.5c.69 0 1.25.56 1.25 1.25v.245c0 .69-.56 1.25-1.25 1.25H8.5v1.5h2.75v1.58h1.5v-1.58h.5a2.755 2.755 0 0 0 2.75-2.75V14a2.755 2.755 0 0 0-2.75-2.75h-2.5c-.69 0-1.25-.56-1.25-1.25v-.255c0-.69.56-1.25 1.25-1.25H15v-1.5h-2.25V5.5zm6.21 13.005H15.5V17.01H20v4.495h-1.5v-1.9a9.95 9.95 0 0 1-6.5 2.4c-5.515 0-10-4.485-10-10 0-1.115.18-2.205.54-3.25l1.42.485A8.5 8.5 0 0 0 3.5 12c0 4.685 3.815 8.5 8.5 8.5 2.03 0 3.945-.715 5.46-1.995" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCurrency: {
  name: 'griddy-currency';
  data: string;
} = {
  name: 'griddy-currency',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m6-2c0 .69.56 1.25 1.25 1.25h2.5A2.755 2.755 0 0 1 16 14v.245a2.755 2.755 0 0 1-2.75 2.75h-.5v1.58h-1.5v-1.58H8.5v-1.5h4.75c.69 0 1.25-.56 1.25-1.25V14c0-.69-.56-1.25-1.25-1.25h-2.5A2.755 2.755 0 0 1 8 10v-.255a2.755 2.755 0 0 1 2.75-2.75h.5V5.5h1.5v1.495H15v1.5h-4.25c-.69 0-1.25.56-1.25 1.25z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCursorArrow: {
  name: 'griddy-cursor-arrow';
  data: string;
} = {
  name: 'griddy-cursor-arrow',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.296 4.466c-.27-1.021.769-1.897 1.73-1.457l16.902 7.746-9.645 2.627-4.228 9.06zm1.585.127 3.564 13.465 2.772-5.94 6.325-1.723-12.66-5.802Z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyCursorClick: {
  name: 'griddy-cursor-click';
  data: string;
} = {
  name: 'griddy-cursor-click',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9 5.5V1h1.5v4.5zM1 9h4.5v1.5H1zm15.78-5.22-3.5 3.5-1.06-1.06 3.5-3.5zm-13-1.06 3.5 3.5-1.06 1.06-3.5-3.5zm-1.06 13 3.5-3.5 1.06 1.06-3.5 3.5z" clip-rule="evenodd"/><path fill="currentColor" d="m20.75 18.75-4.075-4.075 3.585-1.45L9.365 8.712a.5.5 0 0 0-.653.653l4.513 10.895 1.45-3.585 4.075 4.075z"/><path fill="currentColor" fill-rule="evenodd" d="M8.02 9.652c-.427-1.029.603-2.06 1.632-1.633l12.588 5.214-4.234 1.713 3.805 3.804-3.061 3.06-3.804-3.804-1.713 4.234zm1.616-.016 3.58 8.644 1.188-2.936 4.346 4.345.94-.939-4.346-4.346 2.936-1.187z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyDatabaseLine: {
  name: 'griddy-database-line';
  data: string;
} = {
  name: 'griddy-database-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2c-3.855 0-8 .94-8 3v14c0 2.06 4.145 3 8 3s8-.94 8-3V5c0-2.06-4.145-3-8-3m0 1.5c4.255 0 6.39 1.08 6.5 1.5-.11.42-2.245 1.5-6.5 1.5S5.595 5.41 5.5 5.005C5.595 4.59 7.73 3.5 12 3.5M5.5 6.845C7.05 7.63 9.585 8 12 8s4.95-.37 6.5-1.155V9.66c-.09.415-2.23 1.505-6.5 1.505s-6.41-1.09-6.5-1.5zm0 4.665c1.55.785 4.085 1.155 6.5 1.155s4.95-.37 6.5-1.155v2.815c-.09.415-2.225 1.505-6.5 1.505s-6.41-1.09-6.5-1.5zm6.5 8.985c-4.275 0-6.41-1.09-6.5-1.5v-2.82c1.55.785 4.085 1.155 6.5 1.155s4.95-.37 6.5-1.155v2.815c-.09.415-2.225 1.505-6.5 1.505"/></svg>`,
};
export const iconGriddyDownload: {
  name: 'griddy-download';
  data: string;
} = {
  name: 'griddy-download',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.885 16.675a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L6.47 12.03l1.06-1.06 3.72 3.72V3h1.5v11.69l3.72-3.72 1.06 1.06zM19.5 18.25V15.5H21v2.75A2.755 2.755 0 0 1 18.25 21H5.75A2.755 2.755 0 0 1 3 18.25V15.5h1.5v2.75c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyDragIndicator: {
  name: 'griddy-drag-indicator';
  data: string;
} = {
  name: 'griddy-drag-indicator',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6-7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyEdit: {
  name: 'griddy-edit';
  data: string;
} = {
  name: 'griddy-edit',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M20.975 3.025A3.48 3.48 0 0 0 18.5 2a3.48 3.48 0 0 0-2.475 1.025l-13.17 13.17-.845 4.93a.74.74 0 0 0 .21.655c.14.14.335.22.53.22.04 0 .085 0 .125-.01l4.93-.845 13.17-13.17A3.48 3.48 0 0 0 22 5.5a3.48 3.48 0 0 0-1.025-2.475m-13.89 16.72-3.415.585.585-3.415 9.3-9.3 2.83 2.83zm10.36-10.36-2.83-2.83 2.47-2.47c.755-.755 2.07-.755 2.83 0a2 2 0 0 1 0 2.83z"/></svg>`,
};
export const iconGriddyEmailForward: {
  name: 'griddy-email-forward';
  data: string;
} = {
  name: 'griddy-email-forward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.5 9.46v7.79c0 .69.56 1.25 1.25 1.25h8.75V20H4.75A2.755 2.755 0 0 1 2 17.25V6.75A2.755 2.755 0 0 1 4.75 4h14.5A2.755 2.755 0 0 1 22 6.75v7.75h-1.5V9.46L12 14.37zM19.25 5.5H4.75c-.69 0-1.25.56-1.25 1.25v.975L12 12.63l8.5-4.905V6.75c0-.69-.56-1.25-1.25-1.25m.035 10.215 2.65 2.65c.485.49.485 1.285 0 1.77l-2.65 2.65-1.06-1.06L19.95 20h-4.945v-1.5h4.945l-1.725-1.725z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyEmailRead: {
  name: 'griddy-email-read';
  data: string;
} = {
  name: 'griddy-email-read',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="m20.5 9.455-8.5 4.91v.005L3.5 9.46v7.79c0 .69.56 1.25 1.25 1.25h6.75V20H4.75A2.755 2.755 0 0 1 2 17.25V6.75A2.755 2.755 0 0 1 4.75 4h14.5A2.755 2.755 0 0 1 22 6.75v6.745h-1.5zM19.25 5.5H4.75c-.69 0-1.25.56-1.25 1.25v.975L12 12.63l8.5-4.905V6.75c0-.69-.56-1.25-1.25-1.25M16 19.94l4.97-4.97 1.06 1.06-5.145 5.145a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L12.97 19.03l1.06-1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyEmail: {
  name: 'griddy-email';
  data: string;
} = {
  name: 'griddy-email',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M19.25 4H4.75A2.755 2.755 0 0 0 2 6.75v10.5A2.755 2.755 0 0 0 4.75 20h14.5A2.755 2.755 0 0 0 22 17.25V6.75A2.755 2.755 0 0 0 19.25 4M4.75 5.5h14.5c.69 0 1.25.56 1.25 1.25v.975l-8.5 4.91-8.5-4.91V6.75c0-.69.56-1.25 1.25-1.25m14.5 13H4.75c-.69 0-1.25-.56-1.25-1.25V9.46l8.5 4.91 8.5-4.91v7.79c0 .69-.56 1.25-1.25 1.25"/></svg>`,
};
export const iconGriddyEyeLine: {
  name: 'griddy-eye-line';
  data: string;
} = {
  name: 'griddy-eye-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8 12c0 2.205 1.795 4 4 4s4-1.795 4-4-1.795-4-4-4-4 1.795-4 4m1.5 0a2.501 2.501 0 0 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2.065 12.31c.13.29 3.275 7.19 9.935 7.19s9.805-6.895 9.935-7.19l.145-.33-.165-.32c-.15-.295-3.78-7.16-9.915-7.16-6.66 0-9.805 6.905-9.935 7.2l-.135.305zM12 18c-4.95 0-7.755-4.735-8.415-5.995C4.245 10.74 7.055 6 12 6c4.525 0 7.635 4.73 8.4 6.025C19.72 13.32 16.95 18 12 18" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyEyeOffLine: {
  name: 'griddy-eye-off-line';
  data: string;
} = {
  name: 'griddy-eye-off-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="m22.08 11.98-.145.33c-.08.18-1.28 2.815-3.72 4.845l3.065 3.065-1.06 1.06-17.5-17.5 1.06-1.06 3.235 3.235C8.38 5.1 10.035 4.5 12 4.5c6.135 0 9.765 6.87 9.915 7.16zM10.85 9.79l3.36 3.36c.18-.345.29-.735.29-1.15A2.5 2.5 0 0 0 12 9.5c-.42 0-.805.11-1.15.29M16 12c0 .835-.26 1.605-.695 2.245l1.82 1.82c1.785-1.45 2.88-3.3 3.27-4.045-.765-1.295-3.87-6.025-8.4-6.025-1.485 0-2.77.435-3.87 1.07l1.63 1.63A4 4 0 0 1 12 8c2.205 0 4 1.795 4 4" clip-rule="evenodd"/><path fill="currentColor" d="M3.585 12.005C4.245 13.265 7.055 18 12 18c.87 0 1.675-.155 2.415-.405l1.175 1.175c-1.06.45-2.25.73-3.59.73-6.66 0-9.805-6.895-9.935-7.19l-.135-.305.135-.305.005-.01c.097-.209.951-2.048 2.625-3.815L5.77 8.95a14.1 14.1 0 0 0-2.185 3.055"/></svg>`,
};
export const iconGriddyGlobe: {
  name: 'griddy-globe';
  data: string;
} = {
  name: 'griddy-globe',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M12 2C6.485 2 2 6.485 2 12s4.485 10 10 10 10-4.485 10-10S17.515 2 12 2m0 18.245A11.8 11.8 0 0 1 9.76 17.2a12.6 12.6 0 0 1 4.48 0A11.8 11.8 0 0 1 12 20.245m0-4.745c-1.03 0-1.975.115-2.845.29-.32-.895-.55-1.915-.62-3.04h6.935a11.3 11.3 0 0 1-.62 3.04 14.3 14.3 0 0 0-2.845-.29zm-3.465-4.25c.075-1.125.3-2.145.62-3.04.87.175 1.815.29 2.845.29s1.975-.115 2.845-.29c.32.895.55 1.915.62 3.04H8.53zM12 7c-.805 0-1.545-.075-2.24-.2A11.8 11.8 0 0 1 12 3.755c.545.525 1.47 1.55 2.24 3.045-.695.12-1.435.2-2.24.2m2.045-3.24c1.365.34 2.6 1.01 3.62 1.92-.55.275-1.19.54-1.915.765a13 13 0 0 0-1.7-2.685zm-5.79 2.685c-.73-.225-1.365-.49-1.915-.765a8.5 8.5 0 0 1 3.62-1.92c-.56.68-1.175 1.58-1.7 2.685zM7.68 7.84a12.9 12.9 0 0 0-.645 3.41H3.54c.145-1.66.77-3.18 1.735-4.43.665.36 1.47.72 2.405 1.02m-.645 4.91c.07 1.26.305 2.405.645 3.41-.935.295-1.74.66-2.405 1.02a8.43 8.43 0 0 1-1.735-4.43zm1.22 4.805a13 13 0 0 0 1.7 2.685 8.54 8.54 0 0 1-3.62-1.92c.55-.275 1.19-.54 1.915-.765zm7.49 0c.73.225 1.365.49 1.915.765a8.5 8.5 0 0 1-3.62 1.92c.56-.68 1.175-1.58 1.7-2.685zm.575-1.395c.34-1.005.575-2.15.645-3.41h3.495a8.43 8.43 0 0 1-1.735 4.43 14 14 0 0 0-2.405-1.02m.645-4.91a12.9 12.9 0 0 0-.645-3.41 13.7 13.7 0 0 0 2.405-1.02 8.43 8.43 0 0 1 1.735 4.43z"/></svg>`,
};
export const iconGriddyHandsSupport: {
  name: 'griddy-hands-support';
  data: string;
} = {
  name: 'griddy-hands-support',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17 5c0-.8-.31-1.555-.88-2.12A2.99 2.99 0 0 0 14 2c-.745 0-1.45.27-2 .765A2.97 2.97 0 0 0 10 2c-.8 0-1.555.31-2.12.88A2.99 2.99 0 0 0 7 5c0 .8.31 1.555.88 2.12l3.59 3.59c.145.145.34.22.53.22s.385-.075.53-.22l3.59-3.59C16.685 6.555 17 5.8 17 5m-1.94 1.06L12 9.12 8.94 6.06A1.49 1.49 0 0 1 8.5 5c0-.4.155-.775.44-1.06S9.6 3.5 10 3.5s.775.155 1.06.44c.1.1.19.225.27.39a.75.75 0 0 0 1.34 0q.12-.24.27-.39c.565-.565 1.555-.565 2.12 0 .285.285.44.66.44 1.06s-.155.775-.44 1.06m-6.32 6.075c-.34-.51-.875-.86-1.48-.96-.6-.105-1.23.05-1.715.415a.6.6 0 0 0-.082.074l-.048.046-.32-3.825a2.063 2.063 0 0 0-2.045-1.88c-1.13 0-2.05.92-2.05 2.05v6.39l3 5.5v2.06h1.5v-2.44l-3-5.5V8.06a.552.552 0 0 1 1.1-.045L4.015 13l2.595 4.155 1.27-.795-1.62-2.59a.723.723 0 0 1 .18-.97.73.73 0 0 1 1.045.18l1.535 2.305c.29.43.42.955.365 1.47l-.395 3.93v1.325h1.495V20.8l.39-3.895a3.77 3.77 0 0 0-.61-2.455L8.73 12.145zM18.906 7.88A2.06 2.06 0 0 1 20.95 6l-.005-.01c1.13 0 2.05.92 2.05 2.05v6.39l-3 5.5v2.06h-1.5v-2.44l3-5.5V8.045a.552.552 0 0 0-1.1-.045l-.415 4.985-2.595 4.155-1.27-.795 1.62-2.59a.723.723 0 0 0-.18-.97.72.72 0 0 0-.56-.135.72.72 0 0 0-.485.315l-1.535 2.305c-.285.43-.415.955-.365 1.47l.395 4.005v1.25h-1.5v-1.21l-.39-3.895a3.77 3.77 0 0 1 .61-2.455l1.535-2.305c.34-.505.88-.855 1.48-.96.6-.1 1.225.05 1.715.415q.04.033.078.07l.052.05z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyHeart: {
  name: 'griddy-heart';
  data: string;
} = {
  name: 'griddy-heart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M16.5 3.515c-1.825 0-3.49.9-4.5 2.34a5.5 5.5 0 0 0-4.5-2.34 5.503 5.503 0 0 0-3.89 9.39l8.39 8.39 8.39-8.39a5.503 5.503 0 0 0-3.89-9.39m2.83 8.33L12 19.175l-7.33-7.33a3.97 3.97 0 0 1-1.17-2.83c0-2.205 1.795-4 4-4 1.72 0 3.24 1.095 3.79 2.725a.748.748 0 0 0 1.42 0 4 4 0 0 1 3.79-2.725c2.205 0 4 1.795 4 4 0 1.07-.415 2.075-1.17 2.83"/></svg>`,
};
export const iconGriddyHelpCircle: {
  name: 'griddy-help-circle';
  data: string;
} = {
  name: 'griddy-help-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 22C6.485 22 2 17.515 2 12S6.485 2 12 2s10 4.485 10 10-4.485 10-10 10m0-18.5c-4.685 0-8.5 3.815-8.5 8.5s3.815 8.5 8.5 8.5 8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5m.75 11.5h-.005v-.495c0-.655.33-.905 1.02-1.37l.003-.002c.785-.53 1.852-1.25 1.852-3.023a3.61 3.61 0 0 0-3.605-3.605 3.6 3.6 0 0 0-3.33 2.225l1.385.575c.325-.79 1.09-1.3 1.945-1.3 1.16 0 2.105.945 2.105 2.105 0 .975-.47 1.295-1.19 1.78-.71.475-1.68 1.13-1.68 2.61v.5h1.495v.005zm.25 2.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyHome: {
  name: 'griddy-home';
  data: string;
} = {
  name: 'griddy-home',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M19.75 21H14v-5.005a2 2 0 1 0-4 0V21H4.25C3.56 21 3 20.44 3 19.75v-9.315l8.13-7.885a1.24 1.24 0 0 1 1.74 0L21 10.435v9.315c0 .69-.56 1.25-1.25 1.25m-4.25-1.5h4v-8.435L12 3.795 4.5 11.07v8.435h4V16c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v3.505z"/></svg>`,
};
export const iconGriddyHotel: {
  name: 'griddy-hotel';
  data: string;
} = {
  name: 'griddy-hotel',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="m12 3.565 9.436 4.365.63-1.36L12 1.915 1.936 6.57l.63 1.36zm7.25 7.935h-7.5c-.69 0-1.25.56-1.25 1.25v3.75h-7v-7H2V21h1.5v-3h17v3H22v-6.75a2.755 2.755 0 0 0-2.75-2.75m-7.25 5V13h7.25c.69 0 1.25.56 1.25 1.25v2.25zM9 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyImage: {
  name: 'griddy-image';
  data: string;
} = {
  name: 'griddy-image',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20"><path fill="currentColor" fill-rule="evenodd" d="M5.46 2.5h10.416a2.296 2.296 0 0 1 2.292 2.292v10.416a2.296 2.296 0 0 1-2.292 2.292H5.46a2.296 2.296 0 0 1-2.292-2.292V4.792A2.296 2.296 0 0 1 5.46 2.5m10.416 1.25H5.46c-.575 0-1.042.467-1.042 1.042v9.325l3.22-3.221a1.05 1.05 0 0 1 1.476 0l1.137 1.137 3.43-3.429a1.05 1.05 0 0 1 1.475 0l1.762 1.763V4.792c0-.575-.467-1.042-1.042-1.042M5.46 16.25h10.416v.004c.575 0 1.042-.467 1.042-1.042v-3.075l-2.5-2.5-4.167 4.167-1.875-1.875-3.808 3.809c.18.304.508.512.892.512m4.375-9.167a2.084 2.084 0 1 1-4.169-.001 2.084 2.084 0 0 1 4.169.001m-1.25 0a.836.836 0 0 0-.834-.833.836.836 0 0 0-.833.833c0 .459.375.834.833.834a.836.836 0 0 0 .834-.834" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyInfoCircle: {
  name: 'griddy-info-circle';
  data: string;
} = {
  name: 'griddy-info-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 22C6.485 22 2 17.515 2 12S6.485 2 12 2s10 4.485 10 10-4.485 10-10 10m0-18.5c-4.685 0-8.5 3.815-8.5 8.5s3.815 8.5 8.5 8.5 8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5m.75 12.5v-5.5h-1.5V16zM13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyInvoice: {
  name: 'griddy-invoice';
  data: string;
} = {
  name: 'griddy-invoice',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M18.25 2A2.755 2.755 0 0 1 21 4.75v8.75h-4v8H3V4.75A2.755 2.755 0 0 1 5.75 2zM4.5 20h11V4.75c0-.45.11-.875.305-1.25H5.75c-.69 0-1.25.56-1.25 1.25zM17 4.75V12h2.5V4.75a1.25 1.25 0 0 0-2.5 0M9 11h2a2.5 2.5 0 0 1 0 5h-.5v1.5H9V16H7v-1.5h4c.55 0 1-.45 1-1s-.45-1-1-1H9c-1.38 0-2.5-1.115-2.5-2.5A2.5 2.5 0 0 1 9 7.495V6h1.5v1.495h2v1.5H9a1 1 0 0 0-1 1C8 10.55 8.45 11 9 11" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyIot: {
  name: 'griddy-iot';
  data: string;
} = {
  name: 'griddy-iot',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M18.365 6.135c-3.51-3.51-9.22-3.51-12.73 0l-1.06-1.06C8.67.98 15.33.98 19.425 5.075zM12 6.5c1.605 0 3.11.62 4.245 1.755l1.06-1.06A7.46 7.46 0 0 0 12 5c-2.005 0-3.89.78-5.305 2.195l1.06 1.06A5.98 5.98 0 0 1 12 6.5m-4.5 11c0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5v-5c0-2.48-2.02-4.5-4.5-4.5s-4.5 2.02-4.5 4.5zm1.5-5c0-1.655 1.345-3 3-3s3 1.345 3 3v5c0 1.655-1.345 3-3 3s-3-1.345-3-3zm4-.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyKey: {
  name: 'griddy-key';
  data: string;
} = {
  name: 'griddy-key',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.5 8.75C8.5 5.03 11.53 2 15.25 2S22 5.03 22 8.75s-3.03 6.75-6.75 6.75a6.7 6.7 0 0 1-1.91-.28L6.56 22H2v-4.56l6.78-6.78a6.7 6.7 0 0 1-.28-1.91m4.905 4.91c.6.225 1.22.34 1.845.34a5.256 5.256 0 0 0 5.25-5.25 5.256 5.256 0 0 0-5.25-5.25A5.256 5.256 0 0 0 10 8.75c0 .62.115 1.245.34 1.845l.17.455-7.01 7.01v2.44h2.44l1.5-1.5-.72-.72 1.06-1.06.72.72 1.44-1.44-.72-.72 1.06-1.06.72.72 1.95-1.95zM18 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLaptop: {
  name: 'griddy-laptop';
  data: string;
} = {
  name: 'griddy-laptop',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M21 16.5V5.75A2.755 2.755 0 0 0 18.25 3H5.75A2.755 2.755 0 0 0 3 5.75V16.5H2v1.75A2.755 2.755 0 0 0 4.75 21h14.5A2.755 2.755 0 0 0 22 18.25V16.5zM4.5 5.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V16.5h-15zm16 12.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25V18h17z"/></svg>`,
};
export const iconGriddyLayersLine: {
  name: 'griddy-layers-line';
  data: string;
} = {
  name: 'griddy-layers-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.82 13.02a2.8 2.8 0 0 0 1.18.265 2.7 2.7 0 0 0 1.18-.265l8.19-3.89c.44-.21.715-.64.715-1.13s-.275-.92-.715-1.13l-8.19-3.89a2.75 2.75 0 0 0-2.36 0L2.63 6.87c-.44.21-.715.64-.715 1.13s.275.92.715 1.13zm1.715-1.355c-.34.16-.73.16-1.07 0L3.75 8l7.715-3.665c.34-.16.73-.16 1.07 0L20.25 8zM10.82 17.02c.375.18.78.27 1.18.27s.805-.09 1.18-.27L22 12.83v-1.66l-9.465 4.495c-.34.16-.73.16-1.07 0L2 11.17v1.66zm.645 2.645L2 15.17v1.66l8.82 4.19c.375.18.775.265 1.18.265s.805-.09 1.18-.265L22 16.83v-1.66l-9.465 4.495c-.34.16-.73.16-1.07 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLayersTwoLine: {
  name: 'griddy-layers-two-line';
  data: string;
} = {
  name: 'griddy-layers-two-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.82 15.02a2.8 2.8 0 0 0 1.18.265 2.7 2.7 0 0 0 1.18-.265l8.19-3.89c.44-.21.715-.64.715-1.13s-.275-.92-.715-1.13l-8.19-3.89a2.75 2.75 0 0 0-2.36 0L2.63 8.87c-.44.21-.715.64-.715 1.13s.275.92.715 1.13zm1.715-1.355c-.34.16-.73.16-1.07 0L3.75 10l7.715-3.665c.34-.16.73-.16 1.07 0L20.25 10zm-1.07 4c.34.16.73.16 1.07 0L22 13.17v1.66l-8.82 4.19a2.8 2.8 0 0 1-1.18.265 2.7 2.7 0 0 1-1.18-.265L2 14.83v-1.66z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLicenseDraft: {
  name: 'griddy-license-draft';
  data: string;
} = {
  name: 'griddy-license-draft',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M20 2H4v20h7.5v-1.5h-6v-17h13V11H20zm2.28 11.22a2.17 2.17 0 0 0-3.06 0l-5.125 5.125-.742 2.218c-.32.96.59 1.917 1.583 1.577l2.214-.74 5.13-5.12a2.17 2.17 0 0 0 0-3.06m-2 1.06a.67.67 0 0 1 .94 0 .67.67 0 0 1 0 .94l-4.88 4.87-1.404.469.47-1.404zM16.5 7h-9V5.5h9zm-9 3h9V8.5h-9zm4 8.5h-4V17h4zm-4-5.5h4v-1.5h-4z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLicense: {
  name: 'griddy-license';
  data: string;
} = {
  name: 'griddy-license',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4 2h16v20H4zm1.5 1.5v17h13v-17zm11 3.5h-9V5.5h9zm-9 3h9V8.5h-9zm4 8.5h-4V17h4zm-4-5.5h4v-1.5h-4z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLightbulbOff: {
  name: 'griddy-lightbulb-off';
  data: string;
} = {
  name: 'griddy-lightbulb-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M16 16h-1.5c0-1.415.76-2.455 1.5-3.46.77-1.055 1.5-2.055 1.5-3.54 0-3.035-2.465-5.5-5.5-5.5A5.503 5.503 0 0 0 6.5 9c0 1.485.73 2.485 1.5 3.54l.01.013c.731 1 1.49 2.038 1.49 3.447H8c0-.925-.56-1.69-1.21-2.575v-.001C5.95 12.274 5 10.974 5 9c0-3.86 3.14-7 7-7s7 3.14 7 7c0 1.975-.95 3.28-1.79 4.425C16.56 14.31 16 15.075 16 16m-7 4.5V22h6v-1.5zM8 19v-1.5h8V19z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLightbulbOn: {
  name: 'griddy-lightbulb-on';
  data: string;
} = {
  name: 'griddy-lightbulb-on',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M16 16h-1.5c0-1.415.76-2.455 1.5-3.46.77-1.055 1.5-2.055 1.5-3.54 0-3.035-2.465-5.5-5.5-5.5A5.503 5.503 0 0 0 6.5 9c0 1.485.73 2.485 1.5 3.54l.01.013c.731 1 1.49 2.038 1.49 3.447H8c0-.925-.56-1.69-1.21-2.575v-.001C5.95 12.274 5 10.974 5 9c0-3.86 3.14-7 7-7s7 3.14 7 7c0 1.975-.95 3.28-1.79 4.425C16.56 14.31 16 15.075 16 16m-7 4.5V22h6v-1.5zM8 19v-1.5h8V19zM20.72 2.217l-2 2.001 1.06 1.06 2.002-2zM2.218 3.28l1.061-1.06 2.001 2-1.06 1.06zM23 8.5h-2.5V10H23zm-22 0h2.5V10H1zm3.222 4.717L2.22 15.218l1.06 1.061 2.001-2.001-1.06-1.06Zm14.496 1.064 1.06-1.061 2.002 2.001-1.061 1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLinkExternal: {
  name: 'griddy-link-external';
  data: string;
} = {
  name: 'griddy-link-external',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M18.25 19.5c.69 0 1.25-.56 1.25-1.25V12.5H21v5.75A2.755 2.755 0 0 1 18.25 21H5.75A2.755 2.755 0 0 1 3 18.25V5.75A2.755 2.755 0 0 1 5.75 3h5.75v1.5H5.75c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25zM13.5 3h6.25c.69 0 1.25.56 1.25 1.25v6.25h-1.5V5.59l-7.955 8.425-1.09-1.03 8.01-8.485H13.5z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLink: {
  name: 'griddy-link';
  data: string;
} = {
  name: 'griddy-link',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M9 17.5H7.5A5.503 5.503 0 0 1 2 12c0-3.035 2.465-5.5 5.5-5.5H9V8H7.5c-2.205 0-4 1.795-4 4s1.795 4 4 4H9zm7.5 0H15V16h1.5c2.205 0 4-1.795 4-4s-1.795-4-4-4H15V6.5h1.5c3.035 0 5.5 2.465 5.5 5.5s-2.465 5.5-5.5 5.5M7 11.25h10v1.5H7z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLocationPin: {
  name: 'griddy-location-pin';
  data: string;
} = {
  name: 'griddy-location-pin',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.04 21.345c.24.285.59.45.96.45s.72-.165.96-.45l5.185-6.225A8.02 8.02 0 0 0 20 10c0-4.41-3.59-8-8-8s-8 3.59-8 8c0 1.87.66 3.685 1.855 5.12zM5.5 10c0-3.585 2.915-6.5 6.5-6.5s6.5 2.915 6.5 6.5a6.5 6.5 0 0 1-1.505 4.16L12 20.155 7.005 14.16A6.52 6.52 0 0 1 5.5 10m3 0c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5S8.5 8.07 8.5 10m1.5 0a2 2 0 1 1 3.999-.001A2 2 0 0 1 10 10" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyLockOpen: {
  name: 'griddy-lock-open';
  data: string;
} = {
  name: 'griddy-lock-open',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M17.25 10.5H7.5V8.005c0-2.48 2.02-4.5 4.5-4.5a4.49 4.49 0 0 1 4.145 2.75l1.38-.585a5.99 5.99 0 0 0-5.53-3.665c-3.31 0-6 2.695-6 6v2.6c-1.15.33-2 1.385-2 2.645v6A2.755 2.755 0 0 0 6.745 22h10.5a2.755 2.755 0 0 0 2.75-2.75v-6a2.755 2.755 0 0 0-2.75-2.75zm1.25 8.75c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25v-6c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25z"/></svg>`,
};
export const iconGriddyLock: {
  name: 'griddy-lock';
  data: string;
} = {
  name: 'griddy-lock',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M18 10.605V8c0-3.31-2.69-6-6-6S6 4.69 6 8v2.605c-1.15.33-2 1.385-2 2.645v6A2.755 2.755 0 0 0 6.75 22h10.5A2.755 2.755 0 0 0 20 19.25v-6c0-1.255-.85-2.315-2-2.645M12 3.5c2.48 0 4.5 2.02 4.5 4.5v2.5h-9V8c0-2.48 2.02-4.5 4.5-4.5"/></svg>`,
};
export const iconGriddyMagicWand: {
  name: 'griddy-magic-wand';
  data: string;
} = {
  name: 'griddy-magic-wand',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M4.75 8c0-1.79 1.46-3.25 3.25-3.25v-1.5C6.21 3.25 4.75 1.79 4.75 0h-1.5c0 1.79-1.46 3.25-3.25 3.25v1.5c1.79 0 3.25 1.46 3.25 3.25zM4 2.55c.37.58.865 1.075 1.45 1.45-.58.37-1.075.865-1.45 1.45A4.8 4.8 0 0 0 2.55 4 4.8 4.8 0 0 0 4 2.55M16.25 13h-1.5c0 .965-.785 1.75-1.75 1.75v1.5c.965 0 1.75.785 1.75 1.75h1.5c0-.965.785-1.75 1.75-1.75v-1.5c-.965 0-1.75-.785-1.75-1.75M15.47.97c.98-.98 2.58-.98 3.56 0s.98 2.58 0 3.56l-14.5 14.5a2.5 2.5 0 0 1-1.78.735 2.5 2.5 0 0 1-1.78-.735c-.98-.98-.98-2.58 0-3.56zm-13.44 17a1.023 1.023 0 0 0 1.44 0L15.215 6.225l-1.44-1.44L2.03 16.53a1.023 1.023 0 0 0 0 1.44M16.275 5.165 17.97 3.47c.395-.4.395-1.045 0-1.44-.2-.195-.46-.295-.72-.295s-.52.095-.72.295l-1.695 1.695z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyMeetAndGreet: {
  name: 'griddy-meet-and-greet';
  data: string;
} = {
  name: 'griddy-meet-and-greet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.86 6.164a2.75 2.75 0 0 1 2.79-.794l4.923 1.405a1.25 1.25 0 0 1 1.25-1.275H23V7h-2.891l1.295 9.5H23V18h-1.814a1.25 1.25 0 0 1-1.225-1H17.01a2.74 2.74 0 0 1-1.531 1.894l-2.42 1.117a4.75 4.75 0 0 1-4.56-.318l-4.435-2.852-.01.078A1.25 1.25 0 0 1 2.812 18H1v-1.5h1.595L3.891 7H1V5.5h3.177c.612 0 1.11.436 1.226 1h5.152zm6.066 9.336h2.828l-.969-7.104-5.546-1.584a1.25 1.25 0 0 0-1.268.361l-3.675 4.042c.408.303.966.331 1.407.056l3.278-2.05 3.658 5.69q.181.285.287.589M5.268 8l-.982 7.201 5.024 3.23a3.25 3.25 0 0 0 3.12.218l2.42-1.117a1.25 1.25 0 0 0 .527-1.81l-2.857-4.443-2.022 1.264a2.75 2.75 0 0 1-3.402-.388l-.881-.88L9.192 8z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyMenu: {
  name: 'griddy-menu';
  data: string;
} = {
  name: 'griddy-menu',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M21 5.5H3V7h18zm0 5.75H3v1.5h18zM3 17h18v1.5H3z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyMicrophoneOff: {
  name: 'griddy-microphone-off';
  data: string;
} = {
  name: 'griddy-microphone-off',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M19.39 14.06a8 8 0 0 1-1.23 2.04l3.37 3.37-1.06 1.06-17-17.005 1.06-1.06 2.79 2.79A5 5 0 0 1 12 2c2.756 0 5 2.245 5 5v4c0 1.11-.364 2.13-.98 2.96l1.07 1.07c.37-.465.68-.98.916-1.545l1.385.575ZM15.5 7c0-1.93-1.57-3.5-3.5-3.5v.005a3.5 3.5 0 0 0-3.454 2.98l6.4 6.4c.35-.545.555-1.19.555-1.885zM7 9.18V11c0 2.755 2.245 5 5 5 .546 0 1.07-.09 1.566-.255l-1.26-1.26A3.504 3.504 0 0 1 8.5 11v-.32zm5.75 9.78a8 8 0 0 0 3.09-.94l-1.114-1.115a6.5 6.5 0 0 1-2.72.595A6.48 6.48 0 0 1 6 13.49l-1.385.575a7.98 7.98 0 0 0 6.645 4.9v1.54H7v1.5h10v-1.5h-4.25z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyMicrophone: {
  name: 'griddy-microphone';
  data: string;
} = {
  name: 'griddy-microphone',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M17 11c0 2.755-2.245 5-5 5s-5-2.245-5-5V7c0-2.755 2.245-5 5-5s5 2.245 5 5zm-5-7.5c-1.93 0-3.5 1.57-3.5 3.5v4c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5V7c0-1.93-1.57-3.5-3.5-3.5m6.01 9.985 1.385.575a7.99 7.99 0 0 1-6.645 4.9v1.54H17V22H7v-1.5h4.26v-1.54a7.98 7.98 0 0 1-6.645-4.9L6 13.485a6.49 6.49 0 0 0 6.005 4.01 6.49 6.49 0 0 0 6.005-4.01" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyMinusCircle: {
  name: 'griddy-minus-circle';
  data: string;
} = {
  name: 'griddy-minus-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M0 10c0 5.515 4.485 10 10 10s10-4.485 10-10S15.515 0 10 0 0 4.485 0 10m1.5 0c0-4.685 3.815-8.5 8.5-8.5s8.5 3.815 8.5 8.5-3.815 8.5-8.5 8.5-8.5-3.815-8.5-8.5m4-.75h9v1.5h-9z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyMinus: {
  name: 'griddy-minus';
  data: string;
} = {
  name: 'griddy-minus',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M20 11.25H4v1.5h16z"/></svg>`,
};
export const iconGriddyMoonAltCalendar: {
  name: 'griddy-moon-alt-calendar';
  data: string;
} = {
  name: 'griddy-moon-alt-calendar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill="currentColor" d="M4.606 18.646C1.017 14.459 1.503 8.135 5.69 4.546a10.03 10.03 0 0 1 9.818-1.838l1.468.514-1.316.831a9 9 0 0 0-1.13.817c-3.978 3.41-4.44 9.418-1.03 13.396a9.5 9.5 0 0 0 2.25 1.917l1.328.812-1.46.533c-3.895 1.417-8.32.257-11.012-2.882"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>`,
};
export const iconGriddyMoonAlt: {
  name: 'griddy-moon-alt';
  data: string;
} = {
  name: 'griddy-moon-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill="currentColor" d="M4.606 18.646C1.017 14.459 1.503 8.135 5.69 4.546a10.03 10.03 0 0 1 9.818-1.838l1.468.514-1.316.831a9 9 0 0 0-1.13.817c-3.978 3.41-4.44 9.418-1.03 13.396a9.5 9.5 0 0 0 2.25 1.917l1.328.812-1.46.533c-3.895 1.417-8.32.257-11.012-2.882m8.925-14.895a8.52 8.52 0 0 0-6.865 1.933c-3.556 3.05-3.97 8.429-.92 11.986 1.955 2.281 4.988 3.33 7.89 2.837-.46-.383-.884-.81-1.274-1.265-3.941-4.597-3.418-11.539 1.17-15.491"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z"/></clipPath></defs></svg>`,
};
export const iconGriddyMoreHorizontal: {
  name: 'griddy-more-horizontal';
  data: string;
} = {
  name: 'griddy-more-horizontal',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M6.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyNotification: {
  name: 'griddy-notification';
  data: string;
} = {
  name: 'griddy-notification',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="m20 15.05-1.5-2.6V8.5C18.5 4.915 15.585 2 12 2a6.506 6.506 0 0 0-6.5 6.5v3.95L4 15.05V19h4.325c.35 1.71 1.865 3 3.675 3s3.325-1.29 3.675-3H20zm-8 5.45c-.975 0-1.8-.63-2.11-1.5h4.225c-.31.87-1.135 1.5-2.11 1.5zm6.5-3h-13v-2.05l1.5-2.6V8.495c0-2.755 2.245-5 5-5s5 2.245 5 5v4.355l1.5 2.6z"/></svg>`,
};
export const iconGriddyOpenai: {
  name: 'griddy-openai';
  data: string;
} = {
  name: 'griddy-openai',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M20.565 10.185c.455-1.36.3-2.855-.43-4.095a5.04 5.04 0 0 0-5.43-2.42 4.98 4.98 0 0 0-3.76-1.675 5.04 5.04 0 0 0-4.805 3.49A5 5 0 0 0 2.81 7.9a5.04 5.04 0 0 0 .62 5.91 4.97 4.97 0 0 0 .43 4.095 5.04 5.04 0 0 0 5.43 2.42A4.98 4.98 0 0 0 13.05 22a5.04 5.04 0 0 0 4.81-3.49 5 5 0 0 0 3.33-2.415 5.04 5.04 0 0 0-.62-5.905zm-7.52 10.51a3.74 3.74 0 0 1-2.4-.87c.03-.015.085-.045.12-.065l3.985-2.3a.65.65 0 0 0 .33-.565V11.28l1.685.97s.03.025.03.045v4.65a3.75 3.75 0 0 1-3.745 3.75zm-8.055-3.44c-.44-.76-.6-1.65-.445-2.51.03.015.08.05.12.07l3.985 2.3c.2.12.45.12.655 0l4.86-2.81v1.945s-.01.04-.025.05l-4.025 2.325a3.75 3.75 0 0 1-5.12-1.37zM3.94 8.56a3.77 3.77 0 0 1 1.95-1.645v4.735c0 .235.125.45.325.565l4.86 2.805-1.685.97s-.04.015-.055.005L5.31 13.67a3.75 3.75 0 0 1-1.37-5.12zm13.83 3.22-4.86-2.81L14.595 8s.04-.015.055 0l4.025 2.325a3.746 3.746 0 0 1 1.37 5.12 3.77 3.77 0 0 1-1.95 1.645v-4.74a.64.64 0 0 0-.325-.565zm1.675-2.52c-.03-.02-.08-.05-.12-.07l-3.985-2.3a.64.64 0 0 0-.655 0L9.825 9.7V7.755s.01-.04.025-.05l4.025-2.325a3.747 3.747 0 0 1 5.565 3.88zm-10.53 3.465-1.685-.97s-.03-.025-.03-.045V7.055a3.744 3.744 0 0 1 6.145-2.875c-.03.015-.085.045-.12.065l-3.985 2.3a.65.65 0 0 0-.33.565v5.61zm.915-1.97 2.165-1.25 2.165 1.25v2.5l-2.165 1.25-2.165-1.25z"/></svg>`,
};
export const iconGriddyPaintBrush: {
  name: 'griddy-paint-brush';
  data: string;
} = {
  name: 'griddy-paint-brush',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="m16.75 15.311-.383.384a2.75 2.75 0 0 1-1.945.805h-2.868c-.331 0-.65.132-.884.366l-4.399 4.4a2.497 2.497 0 0 1-3.536 0 2.497 2.497 0 0 1 0-3.536l4.4-4.4a1.25 1.25 0 0 0 .366-.883V9.578c0-.729.29-1.428.805-1.944l.914-.914h.001l5.53-5.529 8.06 8.061-6.06 6.06v-.001Zm-7-7-.383.384A1.25 1.25 0 0 0 9 9.578v2.869a2.75 2.75 0 0 1-.806 1.944l-4.399 4.4a.997.997 0 0 0 0 1.414.997.997 0 0 0 1.414 0l4.4-4.4A2.75 2.75 0 0 1 11.554 15h2.868c.332 0 .65-.132.884-.366l.384-.384zm7.001 4.88-5.94-5.94 3.94-3.938 1.438 1.438-1.47 1.469 1.061 1.06 1.47-1.469 1.189 1.19-2.72 2.719 1.061 1.06 2.72-2.719 1.19 1.191z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyPetFriendly: {
  name: 'griddy-pet-friendly';
  data: string;
} = {
  name: 'griddy-pet-friendly',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M6.5 5c0-1.47.955-3 2.5-3s2.5 1.53 2.5 3-.955 3-2.5 3-2.5-1.53-2.5-3M9 3.5c-.388 0-1 .485-1 1.5s.612 1.5 1 1.5 1-.485 1-1.5-.612-1.5-1-1.5M2 10c0-1.47.955-3 2.5-3S7 8.53 7 10s-.955 3-2.5 3S2 11.47 2 10m2.5-1.5c-.388 0-1 .485-1 1.5s.612 1.5 1 1.5 1-.485 1-1.5-.612-1.5-1-1.5M15 2c-1.545 0-2.5 1.53-2.5 3s.955 3 2.5 3 2.5-1.53 2.5-3-.955-3-2.5-3m-1 3c0-1.015.612-1.5 1-1.5s1 .485 1 1.5-.612 1.5-1 1.5-1-.485-1-1.5m3 5c0-1.47.955-3 2.5-3S22 8.53 22 10s-.955 3-2.5 3-2.5-1.53-2.5-3m2.5-1.5c-.388 0-1 .485-1 1.5s.612 1.5 1 1.5 1-.485 1-1.5-.612-1.5-1-1.5M12 9c-1.412 0-2.3.655-2.937 1.479-.303.392-.553.827-.776 1.225l-.1.18c-.191.343-.365.657-.561.95-.185.277-.455.532-.818.826q-.147.12-.32.255c-.278.218-.59.463-.87.72C4.761 15.42 4 16.483 4 18.25 4 20.32 5.68 22 7.75 22c.944 0 1.779-.456 2.42-.807l.064-.035c.726-.396 1.242-.658 1.766-.658s1.04.262 1.766.658l.064.035c.641.35 1.476.807 2.42.807 2.07 0 3.75-1.68 3.75-3.75 0-1.767-.76-2.83-1.618-3.615a15 15 0 0 0-.87-.72q-.173-.135-.32-.255c-.363-.294-.633-.549-.818-.826a14 14 0 0 1-.56-.95l-.1-.18c-.224-.399-.474-.833-.777-1.225C14.301 9.655 13.412 9 12 9m-3.126 4.666c.232-.348.44-.722.629-1.062l.093-.168c.222-.398.425-.745.654-1.04.426-.551.912-.896 1.75-.896s1.324.345 1.75.896c.229.295.431.642.654 1.04l.093.168c.19.34.397.714.629 1.062.315.473.732.843 1.12 1.158q.206.167.394.314c.255.2.491.385.728.602.643.59 1.132 1.277 1.132 2.51 0 1.24-1.01 2.25-2.25 2.25-.524 0-1.04-.262-1.766-.658l-.064-.035C13.78 19.457 12.944 19 12 19s-1.779.456-2.42.807l-.064.035c-.726.396-1.242.658-1.766.658-1.24 0-2.25-1.01-2.25-2.25 0-1.233.49-1.92 1.132-2.51.237-.217.473-.402.728-.602q.188-.148.394-.314c.388-.315.805-.685 1.12-1.158" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyPlayCircle: {
  name: 'griddy-play-circle';
  data: string;
} = {
  name: 'griddy-play-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M2 12c0 5.515 4.485 10 10 10s10-4.485 10-10S17.515 2 12 2 2 6.485 2 12m1.5 0c0-4.685 3.815-8.5 8.5-8.5s8.5 3.815 8.5 8.5-3.815 8.5-8.5 8.5-8.5-3.815-8.5-8.5m6.125 4.215c.195.115.41.17.625.17v-.005c.215 0 .43-.055.625-.17l5.425-3.135c.39-.225.625-.635.625-1.08s-.24-.86-.625-1.085l-5.425-3.135A1.251 1.251 0 0 0 9 8.86v6.27c0 .455.235.86.625 1.085M10.5 14.7V9.3l4.675 2.7z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyPlay: {
  name: 'griddy-play';
  data: string;
} = {
  name: 'griddy-play',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M7.25 20.18c-.215 0-.43-.055-.625-.17A1.24 1.24 0 0 1 6 18.925V5.07a1.251 1.251 0 0 1 1.875-1.085l12 6.93c.39.225.625.63.625 1.085s-.235.855-.625 1.085l-12 6.93c-.195.115-.41.17-.625.17zM7.5 5.505v12.99L18.75 12z"/></svg>`,
};
export const iconGriddyPlusCircle: {
  name: 'griddy-plus-circle';
  data: string;
} = {
  name: 'griddy-plus-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m7.75-.75V7.5h1.5v3.75h3.75v1.5h-3.75v3.75h-1.5v-3.75H7.5v-1.5z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyPlus: {
  name: 'griddy-plus';
  data: string;
} = {
  name: 'griddy-plus',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M20 11.25h-7.25V4h-1.5v7.25H4v1.5h7.25V20h1.5v-7.25H20z"/></svg>`,
};
export const iconGriddyRefresh: {
  name: 'griddy-refresh';
  data: string;
} = {
  name: 'griddy-refresh',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M19.5 7.03V3H21v5.75c0 .69-.56 1.25-1.25 1.25H14V8.5h4.63a7.5 7.5 0 0 0-6.63-4 7.48 7.48 0 0 0-6.93 4.63l-1.385-.575A8.97 8.97 0 0 1 12 3c3.06 0 5.86 1.56 7.5 4.03M5.37 15.5a7.53 7.53 0 0 0 6.63 4 7.48 7.48 0 0 0 6.93-4.63l1.385.575A8.97 8.97 0 0 1 12 21a9.03 9.03 0 0 1-7.5-4.025V21H3v-5.75c0-.69.56-1.25 1.25-1.25H10v1.5z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddySearchCheck: {
  name: 'griddy-search-check';
  data: string;
} = {
  name: 'griddy-search-check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="m16.16 15.1 5.62 5.62-1.06 1.06-5.62-5.62A7.96 7.96 0 0 1 10 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8a7.96 7.96 0 0 1-1.84 5.1M3.5 10c0 3.585 2.915 6.5 6.5 6.5s6.5-2.915 6.5-6.5-2.915-6.5-6.5-6.5A6.506 6.506 0 0 0 3.5 10m3.78-.28 1.47 1.47 3.97-3.97 1.06 1.06-4.145 4.145a1.25 1.25 0 0 1-.885.365c-.32 0-.64-.12-.885-.365L6.22 10.78z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddySearch: {
  name: 'griddy-search';
  data: string;
} = {
  name: 'griddy-search',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="m21.78 20.72-5.62-5.62A7.96 7.96 0 0 0 18 10c0-4.41-3.59-8-8-8s-8 3.59-8 8 3.59 8 8 8a7.96 7.96 0 0 0 5.1-1.84l5.62 5.62zM10 16.5A6.506 6.506 0 0 1 3.5 10c0-3.585 2.915-6.5 6.5-6.5s6.5 2.915 6.5 6.5-2.915 6.5-6.5 6.5"/></svg>`,
};
export const iconGriddySettings: {
  name: 'griddy-settings';
  data: string;
} = {
  name: 'griddy-settings',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M9.995 21.799c.655.13 1.33.2 2.005.2v-.005c.67 0 1.35-.065 2.005-.2.58-.115.995-.63.995-1.225v-1.155a7.8 7.8 0 0 0 1.925-1.11l1 .575c.515.295 1.17.195 1.555-.245a10 10 0 0 0 2.01-3.48 1.25 1.25 0 0 0-.565-1.47l-1-.575a8.2 8.2 0 0 0 0-2.22l1-.58c.51-.295.75-.915.565-1.47a10 10 0 0 0-2.01-3.48c-.39-.44-1.04-.54-1.555-.245l-1 .575a8 8 0 0 0-1.92-1.11V3.424c0-.59-.42-1.11-.995-1.225-1.31-.27-2.7-.27-4.015 0-.58.115-.995.63-.995 1.225v1.155a7.8 7.8 0 0 0-1.925 1.11l-1-.575a1.25 1.25 0 0 0-1.555.245 10 10 0 0 0-2.01 3.48c-.185.555.05 1.175.565 1.47l1 .58a8.2 8.2 0 0 0 0 2.22l-1 .58c-.51.295-.75.915-.565 1.47a9.9 9.9 0 0 0 2.01 3.48c.39.44 1.04.54 1.555.245l1-.575c.59.46 1.235.83 1.925 1.11v1.155c0 .59.42 1.11.995 1.225m3.505-1.43a8.6 8.6 0 0 1-3 0v-2.02l-.52-.17a6.5 6.5 0 0 1-2.325-1.345l-.405-.365-1.75 1.01A8.4 8.4 0 0 1 4 14.884l1.75-1.01-.11-.53q-.141-.661-.14-1.345c0-.455.05-.905.14-1.345l.11-.53L4 9.114a8.4 8.4 0 0 1 1.5-2.595l1.75 1.01.405-.365A6.4 6.4 0 0 1 9.98 5.819l.52-.17v-2.02a8.6 8.6 0 0 1 3 0v2.015l.52.17c.865.28 1.645.735 2.325 1.345l.405.365 1.75-1.01A8.4 8.4 0 0 1 20 9.109l-1.75 1.01.11.53q.141.661.14 1.345c0 .455-.05.905-.14 1.345l-.11.53 1.75 1.01a8.4 8.4 0 0 1-1.5 2.6l-1.75-1.01-.405.365a6.4 6.4 0 0 1-2.325 1.345l-.52.17zM8 11.999c0 2.205 1.795 4 4 4s4-1.795 4-4-1.795-4-4-4-4 1.795-4 4m1.5 0a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyShieldCheck: {
  name: 'griddy-shield-check';
  data: string;
} = {
  name: 'griddy-shield-check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.375 19.115 12 22.365v.005l5.625-3.25A6.77 6.77 0 0 0 21 13.275V5.1c0-.565-.38-1.065-.925-1.21L12 1.725l-8.075 2.16C3.38 4.035 3 4.53 3 5.095v8.175a6.77 6.77 0 0 0 3.375 5.845M4.5 13.27V5.285l7.5-2.01 7.5 2.01v7.985a5.26 5.26 0 0 1-2.625 4.545L12 20.63l-4.875-2.815A5.26 5.26 0 0 1 4.5 13.27m5.366.655c.245.245.565.365.885.365s.64-.12.885-.365L16.78 8.78l-1.06-1.06-4.97 4.97-1.97-1.97-1.06 1.06 2.145 2.145Z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyShieldPerson: {
  name: 'griddy-shield-person';
  data: string;
} = {
  name: 'griddy-shield-person',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="m12 1.725 8.075 2.16c.545.15.925.645.925 1.21v8.18a6.77 6.77 0 0 1-3.375 5.845L12 22.37l-5.625-3.25A6.77 6.77 0 0 1 3 13.275v-8.18c0-.565.38-1.065.925-1.21zM7.825 17.43l-.185.69h-.01l4.36 2.515 4.36-2.515-.185-.69a1.25 1.25 0 0 0-1.205-.925H9.03c-.565 0-1.06.38-1.205.925m9.85-.19a5.26 5.26 0 0 0 1.825-3.965v-7.99L12 3.275l-7.5 2.01v7.99c0 1.535.685 2.98 1.825 3.965l.055-.2A2.75 2.75 0 0 1 9.035 15h5.93c1.24 0 2.335.84 2.655 2.04zM12 13.5c-2.205 0-4-1.795-4-4s1.795-4 4-4 4 1.795 4 4-1.795 4-4 4m0-1.5a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5" clip-rule="evenodd"/></svg>`,
};
export const iconGriddySparks: {
  name: 'griddy-sparks';
  data: string;
} = {
  name: 'griddy-sparks',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.69 1.98c0 4 3.25 7.25 7.25 7.25v1.5c-3.995 0-7.25 3.25-7.25 7.25h-1.5c0-4-3.25-7.25-7.25-7.25v-1.5c4 0 7.25-3.25 7.25-7.25zm-5.22 8a8.78 8.78 0 0 1 4.47 4.47 8.78 8.78 0 0 1 4.47-4.47 8.78 8.78 0 0 1-4.47-4.47 8.78 8.78 0 0 1-4.47 4.47M17.25 14h1.5c0 1.79 1.46 3.25 3.25 3.25v1.5c-1.79 0-3.25 1.46-3.25 3.25h-1.5c0-1.79-1.46-3.25-3.25-3.25v-1.5c1.79 0 3.25-1.46 3.25-3.25m-.7 4c.585.375 1.08.87 1.45 1.45.375-.585.87-1.08 1.45-1.45A4.8 4.8 0 0 1 18 16.55 4.8 4.8 0 0 1 16.55 18" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyStar: {
  name: 'griddy-star';
  data: string;
} = {
  name: 'griddy-star',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M6.49 21.59c-.26 0-.514-.08-.734-.24-.39-.28-.58-.75-.5-1.225l.94-5.49L2.21 10.75a1.23 1.23 0 0 1-.315-1.28c.15-.455.535-.78 1.01-.85l5.51-.8 2.464-4.99c.21-.43.64-.695 1.12-.695s.91.265 1.12.695l2.466 4.99 5.51.8a1.247 1.247 0 0 1 .695 2.13l-3.986 3.885.94 5.485a1.25 1.25 0 0 1-1.815 1.32L12 18.85l-4.93 2.59a1.3 1.3 0 0 1-.584.145zM12 17.16l5.18 2.72-.99-5.765 4.19-4.085-5.79-.84L12 3.945 9.41 9.19l-5.79.84 4.19 4.085-.99 5.765z"/></svg>`,
};
export const iconGriddyStickyNote: {
  name: 'griddy-sticky-note';
  data: string;
} = {
  name: 'griddy-sticky-note',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18"><path fill="currentColor" d="M0 0v18h11.56L18 11.56V0zm1.5 1.5h15v9h-4.75c-.69 0-1.25.56-1.25 1.25v4.75h-9zM15.44 12 12 15.44V12z"/></svg>`,
};
export const iconGriddyStore: {
  name: 'griddy-store';
  data: string;
} = {
  name: 'griddy-store',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M19.375 4H4.625L2 8.55V13h1v7h1.5v-7h4v7H21v-7h1V8.55zM3.5 11.5V8.95L5.495 5.5H18.51l1.995 3.45v2.55zm16 7H10V13h9.5z"/></svg>`,
};
export const iconGriddySync: {
  name: 'griddy-sync';
  data: string;
} = {
  name: 'griddy-sync',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M15.25 3H21v1.5h-4.03A9.02 9.02 0 0 1 21 12c0 3.65-2.18 6.915-5.555 8.315l-.575-1.385A7.475 7.475 0 0 0 19.5 12c0-2.8-1.57-5.345-4-6.63V10H14V4.25c0-.69.56-1.25 1.25-1.25M4.5 12a7.53 7.53 0 0 0 4 6.63V14H10v5.75c0 .69-.56 1.25-1.25 1.25H3v-1.5h4.025A9.05 9.05 0 0 1 3 12c0-3.65 2.18-6.915 5.555-8.315L9.13 5.07A7.475 7.475 0 0 0 4.5 12" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyTag: {
  name: 'griddy-tag';
  data: string;
} = {
  name: 'griddy-tag',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M11.865 21.425c.245.245.565.365.885.365l-.005.005c.32 0 .64-.12.885-.365l7.795-7.795a1.26 1.26 0 0 0 0-1.77L11.56 2H4.75A2.755 2.755 0 0 0 2 4.75v6.81zm.885-1.235L3.5 10.94V4.75c0-.69.56-1.25 1.25-1.25h6.19l9.25 9.25zM7.5 6.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyTemperature: {
  name: 'griddy-temperature';
  data: string;
} = {
  name: 'griddy-temperature',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M11.5 5.5C11.5 3.57 9.93 2 8 2S4.5 3.57 4.5 5.5v7.935C3.54 14.375 3 15.655 3 17c0 2.755 2.245 5 5 5s5-2.245 5-5c0-1.35-.54-2.63-1.5-3.565zM8 20.5c-1.93 0-3.5-1.57-3.5-3.5 0-1.025.45-2 1.235-2.665L6 14.11V5.5a2 2 0 1 1 4 0v8.61l.265.225A3.5 3.5 0 0 1 11.5 17c0 1.93-1.57 3.5-3.5 3.5"/><path fill="currentColor" d="M8.75 15.71V8.5h-1.5v7.21c-.445.26-.75.74-.75 1.29 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.555-.305-1.03-.75-1.29M21 4h-6.5v1.5H21zm-2 3.5h-4.5V9H19zm2 3.5h-6.5v1.5H21zm-2 3.5h-4.5V16H19z"/></svg>`,
};
export const iconGriddyThermometer: {
  name: 'griddy-thermometer';
  data: string;
} = {
  name: 'griddy-thermometer',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M15.5 13.435V5.5C15.5 3.57 13.93 2 12 2S8.5 3.57 8.5 5.5v7.935C7.54 14.375 7 15.655 7 17c0 2.755 2.245 5 5 5s5-2.245 5-5c0-1.35-.54-2.63-1.5-3.565M12 20.5c-1.93 0-3.5-1.57-3.5-3.5 0-1.025.45-2 1.235-2.665L10 14.11V5.5a2 2 0 1 1 4 0h-2.5V7H14v1.5h-2.5V10H14v4.11l.265.225A3.5 3.5 0 0 1 15.5 17c0 1.93-1.57 3.5-3.5 3.5"/><path fill="currentColor" d="M12.75 15.71V11.5h-1.5v4.21c-.445.26-.75.74-.75 1.29 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.555-.305-1.03-.75-1.29"/></svg>`,
};
export const iconGriddyThumbsDown: {
  name: 'griddy-thumbs-down';
  data: string;
} = {
  name: 'griddy-thumbs-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M22 2H8.645c-2.15 0-4.04 1.45-4.59 3.53L2.19 12.545c-.22.83-.045 1.7.48 2.385a2.74 2.74 0 0 0 2.18 1.075H9v3.25a2.755 2.755 0 0 0 2.75 2.75h1.5c.69 0 1.25-.56 1.25-1.25V17.15l2.685-4.645H22zm-9 14.745V20.5h-1.25c-.69 0-1.25-.56-1.25-1.25V14.5H4.85c-.39 0-.75-.18-.99-.49a1.24 1.24 0 0 1-.215-1.085L5.51 5.91a3.26 3.26 0 0 1 3.14-2.415h7.355v8.055l-3 5.195zM20.5 11h-3V3.5h3z"/></svg>`,
};
export const iconGriddyThumbsUp: {
  name: 'griddy-thumbs-up';
  data: string;
} = {
  name: 'griddy-thumbs-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M21.33 9.075A2.74 2.74 0 0 0 19.15 8H15V4.75A2.755 2.755 0 0 0 12.25 2h-1.5c-.69 0-1.25.56-1.25 1.25v3.605L6.815 11.5H2V22h13.355c2.15 0 4.04-1.45 4.59-3.53l1.865-7.015c.22-.83.045-1.7-.48-2.385zM6.5 20.5h-3V13h3zm13.855-9.43-1.865 7.015a3.26 3.26 0 0 1-3.14 2.415H7.995v-8.05l3-5.195V3.5h1.25c.69 0 1.25.56 1.25 1.25V9.5h5.65c.39 0 .75.18.99.49s.315.705.215 1.085z"/></svg>`,
};
export const iconGriddyTimeBack: {
  name: 'griddy-time-back';
  data: string;
} = {
  name: 'griddy-time-back',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M5.5 4.4A9.95 9.95 0 0 1 12 2c5.515 0 10 4.49 10 10.005s-4.485 10-10 10-10-4.485-10-10c0-1.115.18-2.205.54-3.25l1.42.485A8.5 8.5 0 0 0 3.5 12c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5c-2.03 0-3.945.72-5.465 2H9V7H5.25C4.56 7 4 6.44 4 5.75V2h1.5zm5.75 7.91V6.495h1.5v5.195l3.03 3.03-1.06 1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyTranslate: {
  name: 'griddy-translate';
  data: string;
} = {
  name: 'griddy-translate',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="m12.275 12.08-.675 1.34a14.8 14.8 0 0 1-3.84-2.82 14.8 14.8 0 0 1-3.86 2.82l-.675-1.34a13.3 13.3 0 0 0 3.53-2.6A14.6 14.6 0 0 1 4.665 6H6.31c.4.825.89 1.595 1.445 2.32A13.2 13.2 0 0 0 9.8 4.5H2V3h4.995V1h1.5v1.995h5v1.5H11.37a14.65 14.65 0 0 1-2.62 4.99 13.2 13.2 0 0 0 3.525 2.595M21.77 22h-1.59l-1.06-3h-5.24l-1.06 3h-1.59l4.24-12h2.06zM16.5 11.585 14.41 17.5h4.18z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyTrashAlt: {
  name: 'griddy-trash-alt';
  data: string;
} = {
  name: 'griddy-trash-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M21 5h-5v-.25A2.755 2.755 0 0 0 13.25 2h-2.5A2.755 2.755 0 0 0 8 4.75V5H3v1.5h1v12.75A2.755 2.755 0 0 0 6.75 22h10.5A2.755 2.755 0 0 0 20 19.25V6.5h1zM9.5 4.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25V5h-5zm9 14.5c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25V6.5h13zm-8-9.75H9v8h1.5zm3 0H15v8h-1.5z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyTrendUp: {
  name: 'griddy-trend-up';
  data: string;
} = {
  name: 'griddy-trend-up',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M20.75 5H15.5v1.5h3.94l-5.94 5.94-3.5-3.5-8.03 8.03 1.06 1.06L10 11.06l3.5 3.5 7-7v3.94H22V6.25C22 5.56 21.44 5 20.75 5"/></svg>`,
};
export const iconGriddyUnfoldLess: {
  name: 'griddy-unfold-less';
  data: string;
} = {
  name: 'griddy-unfold-less',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M11.115 9.175c.245.245.565.365.885.365s.64-.12.885-.365L17.53 4.53l-1.06-1.06L12 7.94 7.53 3.47 6.47 4.53zM12 16.06l4.47 4.47 1.06-1.06-4.645-4.645a1.26 1.26 0 0 0-1.77 0L6.47 19.47l1.06 1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyUnfoldMore: {
  name: 'griddy-unfold-more';
  data: string;
} = {
  name: 'griddy-unfold-more',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="m12 4.56 4.47 4.47 1.06-1.06-4.645-4.645a1.26 1.26 0 0 0-1.77 0L6.47 7.97l1.06 1.06zm-.885 16.115c.245.245.565.365.885.365s.64-.12.885-.365l4.645-4.645-1.06-1.06L12 19.44l-4.47-4.47-1.06 1.06z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyUploadCircle: {
  name: 'griddy-upload-circle';
  data: string;
} = {
  name: 'griddy-upload-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m3.72-1.06 3.895-3.895a1.26 1.26 0 0 1 1.77 0l3.895 3.895L15.72 12l-2.97-2.97v8.47h-1.5V9.03L8.28 12z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyUserCircle: {
  name: 'griddy-user-circle';
  data: string;
} = {
  name: 'griddy-user-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m5.63 6.665-.14.525h.005a8.44 8.44 0 0 0 4.51 1.31 8.44 8.44 0 0 0 4.51-1.31l-.14-.525a2.26 2.26 0 0 0-2.175-1.67H9.805c-1.02 0-1.91.69-2.175 1.67m6.57-3.17c1.665 0 3.13 1.11 3.595 2.705v.005A8.48 8.48 0 0 0 20.5 12c0-4.685-3.815-8.5-8.5-8.5s-8.5 3.815-8.495 8.495A8.47 8.47 0 0 0 6.21 18.2a3.755 3.755 0 0 1 3.595-2.705zM7.5 9.5C7.5 7.02 9.52 5 12 5s4.5 2.02 4.5 4.5S14.48 14 12 14s-4.5-2.02-4.5-4.5m1.5 0c0 1.655 1.345 3 3 3s3-1.345 3-3-1.345-3-3-3-3 1.345-3 3" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyUser: {
  name: 'griddy-user';
  data: string;
} = {
  name: 'griddy-user',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M6.5 7.5c0 3.035 2.465 5.5 5.5 5.5s5.5-2.465 5.5-5.5S15.035 2 12 2a5.503 5.503 0 0 0-5.5 5.5m1.5 0c0-2.205 1.795-4 4-4s4 1.795 4 4-1.795 4-4 4-4-1.795-4-4m10.57 10.91 1.015 3.785 1.45-.39-1.015-3.785a4.76 4.76 0 0 0-4.59-3.52H8.57a4.75 4.75 0 0 0-4.59 3.52l-1.015 3.785 1.45.39L5.43 18.41A3.25 3.25 0 0 1 8.57 16h6.86c1.47 0 2.76.99 3.14 2.41" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyUsersEvent: {
  name: 'griddy-users-event';
  data: string;
} = {
  name: 'griddy-users-event',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M7 9C5.07 9 3.5 7.43 3.5 5.5S5.07 2 7 2s3.5 1.57 3.5 3.5S8.93 9 7 9m0-5.5a2 2 0 1 0-.001 3.999A2 2 0 0 0 7 3.5m6.5 2C13.5 7.43 15.07 9 17 9s3.5-1.57 3.5-3.5S18.93 2 17 2s-3.5 1.57-3.5 3.5m1.5 0a2 2 0 1 1 3.999-.001A2 2 0 0 1 15 5.5m-6.5 7c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5S13.93 9 12 9s-3.5 1.57-3.5 3.5m1.5 0a2 2 0 1 1 3.999-.001A2 2 0 0 1 10 12.5m5.92 7.425.61 2.27v-.005l1.45-.39-.61-2.265a2.75 2.75 0 0 0-2.655-2.04h-5.43c-1.24 0-2.335.84-2.655 2.04l-.61 2.27 1.45.39.61-2.27c.145-.545.64-.925 1.205-.925h5.43c.565 0 1.06.38 1.205.925m4.505-7 .74 2.77 1.45-.39-.74-2.765a2.75 2.75 0 0 0-2.655-2.04h-2.215V12h2.215c.565 0 1.06.38 1.205.925m-19.04 2.38 1.45.39v-.005l.74-2.77c.145-.545.64-.925 1.205-.925h2.215v-1.5H4.78c-1.24 0-2.335.84-2.655 2.04z" clip-rule="evenodd"/></svg>`,
};
export const iconGriddyWalletLine: {
  name: 'griddy-wallet-line';
  data: string;
} = {
  name: 'griddy-wallet-line',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="currentColor" d="M21 10.525v-.77a2.755 2.755 0 0 0-2.75-2.75H4.255A.76.76 0 0 1 3.5 6.25c0-.415.34-.755.755-.755H20v-1.5H4.255A2.26 2.26 0 0 0 2 6.245v11a2.755 2.755 0 0 0 2.75 2.75h13.5a2.755 2.755 0 0 0 2.75-2.75v-.775c.57-.115 1-.62 1-1.225v-3.5c0-.605-.43-1.11-1-1.225zM20.5 15h-3.94l-1.5-1.5 1.5-1.5h3.94zm-2.25 3.5H4.75c-.69 0-1.25-.56-1.25-1.25V8.365c.235.085.49.14.755.14H18.25c.69 0 1.25.56 1.25 1.25v.745h-3.56l-2.115 2.115a1.26 1.26 0 0 0 0 1.77L15.94 16.5h3.56v.75c0 .69-.56 1.25-1.25 1.25"/></svg>`,
};
export const iconGriddyWifi: {
  name: 'griddy-wifi';
  data: string;
} = {
  name: 'griddy-wifi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 5.5c3.605 0 6.994 1.405 9.545 3.955l1.06-1.06A14.9 14.9 0 0 0 11.999 4C7.996 4 4.23 5.56 1.396 8.395l1.06 1.06A13.41 13.41 0 0 1 12 5.5m-6.366 7.135-1.06-1.06A10.43 10.43 0 0 1 12 8.5c2.805 0 5.44 1.09 7.425 3.075l-1.06 1.06A8.94 8.94 0 0 0 12 10a8.94 8.94 0 0 0-6.365 2.635M12 14.5c1.2 0 2.33.47 3.18 1.32h.01l1.06-1.06a5.98 5.98 0 0 0-4.245-1.755c-1.605 0-3.11.62-4.245 1.755l1.06 1.06c.85-.85 1.98-1.32 3.18-1.32m1.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" clip-rule="evenodd"/></svg>`,
};
export type sbnbIcon =
  | 'griddy-alert-circle'
  | 'griddy-alert-triangle'
  | 'griddy-analyze-voice'
  | 'griddy-announcement-alt-02'
  | 'griddy-arrow-elbow-down-right'
  | 'griddy-arrow-left'
  | 'griddy-arrow-right'
  | 'griddy-arrow-up'
  | 'griddy-attachment-alt-01'
  | 'griddy-attachment'
  | 'griddy-book-open'
  | 'griddy-book'
  | 'griddy-briefcase-alt'
  | 'griddy-calendar-check'
  | 'griddy-calendar-date'
  | 'griddy-calendar-time'
  | 'griddy-calendar'
  | 'griddy-chart-line-data'
  | 'griddy-chart-line-smooth'
  | 'griddy-chat-bubble-text'
  | 'griddy-check-circle-alt-01'
  | 'griddy-check-circle'
  | 'griddy-check'
  | 'griddy-checkbox'
  | 'griddy-chevron-down'
  | 'griddy-chevron-left'
  | 'griddy-chevron-right'
  | 'griddy-chevron-up'
  | 'griddy-circle-dashed'
  | 'griddy-clipboard-list'
  | 'griddy-close-circle'
  | 'griddy-close'
  | 'griddy-code'
  | 'griddy-console'
  | 'griddy-copy'
  | 'griddy-credit-card'
  | 'griddy-currency-exchange'
  | 'griddy-currency'
  | 'griddy-cursor-arrow'
  | 'griddy-cursor-click'
  | 'griddy-database-line'
  | 'griddy-download'
  | 'griddy-drag-indicator'
  | 'griddy-edit'
  | 'griddy-email-forward'
  | 'griddy-email-read'
  | 'griddy-email'
  | 'griddy-eye-line'
  | 'griddy-eye-off-line'
  | 'griddy-globe'
  | 'griddy-hands-support'
  | 'griddy-heart'
  | 'griddy-help-circle'
  | 'griddy-home'
  | 'griddy-hotel'
  | 'griddy-image'
  | 'griddy-info-circle'
  | 'griddy-invoice'
  | 'griddy-iot'
  | 'griddy-key'
  | 'griddy-laptop'
  | 'griddy-layers-line'
  | 'griddy-layers-two-line'
  | 'griddy-license-draft'
  | 'griddy-license'
  | 'griddy-lightbulb-off'
  | 'griddy-lightbulb-on'
  | 'griddy-link-external'
  | 'griddy-link'
  | 'griddy-location-pin'
  | 'griddy-lock-open'
  | 'griddy-lock'
  | 'griddy-magic-wand'
  | 'griddy-meet-and-greet'
  | 'griddy-menu'
  | 'griddy-microphone-off'
  | 'griddy-microphone'
  | 'griddy-minus-circle'
  | 'griddy-minus'
  | 'griddy-moon-alt-calendar'
  | 'griddy-moon-alt'
  | 'griddy-more-horizontal'
  | 'griddy-notification'
  | 'griddy-openai'
  | 'griddy-paint-brush'
  | 'griddy-pet-friendly'
  | 'griddy-play-circle'
  | 'griddy-play'
  | 'griddy-plus-circle'
  | 'griddy-plus'
  | 'griddy-refresh'
  | 'griddy-search-check'
  | 'griddy-search'
  | 'griddy-settings'
  | 'griddy-shield-check'
  | 'griddy-shield-person'
  | 'griddy-sparks'
  | 'griddy-star'
  | 'griddy-sticky-note'
  | 'griddy-store'
  | 'griddy-sync'
  | 'griddy-tag'
  | 'griddy-temperature'
  | 'griddy-thermometer'
  | 'griddy-thumbs-down'
  | 'griddy-thumbs-up'
  | 'griddy-time-back'
  | 'griddy-translate'
  | 'griddy-trash-alt'
  | 'griddy-trend-up'
  | 'griddy-unfold-less'
  | 'griddy-unfold-more'
  | 'griddy-upload-circle'
  | 'griddy-user-circle'
  | 'griddy-user'
  | 'griddy-users-event'
  | 'griddy-wallet-line'
  | 'griddy-wifi';
export const sbnbIcon = {
  'griddy-alert-circle': 'griddy-alert-circle' as sbnbIcon,
  'griddy-alert-triangle': 'griddy-alert-triangle' as sbnbIcon,
  'griddy-analyze-voice': 'griddy-analyze-voice' as sbnbIcon,
  'griddy-announcement-alt-02': 'griddy-announcement-alt-02' as sbnbIcon,
  'griddy-arrow-elbow-down-right': 'griddy-arrow-elbow-down-right' as sbnbIcon,
  'griddy-arrow-left': 'griddy-arrow-left' as sbnbIcon,
  'griddy-arrow-right': 'griddy-arrow-right' as sbnbIcon,
  'griddy-arrow-up': 'griddy-arrow-up' as sbnbIcon,
  'griddy-attachment-alt-01': 'griddy-attachment-alt-01' as sbnbIcon,
  'griddy-attachment': 'griddy-attachment' as sbnbIcon,
  'griddy-book-open': 'griddy-book-open' as sbnbIcon,
  'griddy-book': 'griddy-book' as sbnbIcon,
  'griddy-briefcase-alt': 'griddy-briefcase-alt' as sbnbIcon,
  'griddy-calendar-check': 'griddy-calendar-check' as sbnbIcon,
  'griddy-calendar-date': 'griddy-calendar-date' as sbnbIcon,
  'griddy-calendar-time': 'griddy-calendar-time' as sbnbIcon,
  'griddy-calendar': 'griddy-calendar' as sbnbIcon,
  'griddy-chart-line-data': 'griddy-chart-line-data' as sbnbIcon,
  'griddy-chart-line-smooth': 'griddy-chart-line-smooth' as sbnbIcon,
  'griddy-chat-bubble-text': 'griddy-chat-bubble-text' as sbnbIcon,
  'griddy-check-circle-alt-01': 'griddy-check-circle-alt-01' as sbnbIcon,
  'griddy-check-circle': 'griddy-check-circle' as sbnbIcon,
  'griddy-check': 'griddy-check' as sbnbIcon,
  'griddy-checkbox': 'griddy-checkbox' as sbnbIcon,
  'griddy-chevron-down': 'griddy-chevron-down' as sbnbIcon,
  'griddy-chevron-left': 'griddy-chevron-left' as sbnbIcon,
  'griddy-chevron-right': 'griddy-chevron-right' as sbnbIcon,
  'griddy-chevron-up': 'griddy-chevron-up' as sbnbIcon,
  'griddy-circle-dashed': 'griddy-circle-dashed' as sbnbIcon,
  'griddy-clipboard-list': 'griddy-clipboard-list' as sbnbIcon,
  'griddy-close-circle': 'griddy-close-circle' as sbnbIcon,
  'griddy-close': 'griddy-close' as sbnbIcon,
  'griddy-code': 'griddy-code' as sbnbIcon,
  'griddy-console': 'griddy-console' as sbnbIcon,
  'griddy-copy': 'griddy-copy' as sbnbIcon,
  'griddy-credit-card': 'griddy-credit-card' as sbnbIcon,
  'griddy-currency-exchange': 'griddy-currency-exchange' as sbnbIcon,
  'griddy-currency': 'griddy-currency' as sbnbIcon,
  'griddy-cursor-arrow': 'griddy-cursor-arrow' as sbnbIcon,
  'griddy-cursor-click': 'griddy-cursor-click' as sbnbIcon,
  'griddy-database-line': 'griddy-database-line' as sbnbIcon,
  'griddy-download': 'griddy-download' as sbnbIcon,
  'griddy-drag-indicator': 'griddy-drag-indicator' as sbnbIcon,
  'griddy-edit': 'griddy-edit' as sbnbIcon,
  'griddy-email-forward': 'griddy-email-forward' as sbnbIcon,
  'griddy-email-read': 'griddy-email-read' as sbnbIcon,
  'griddy-email': 'griddy-email' as sbnbIcon,
  'griddy-eye-line': 'griddy-eye-line' as sbnbIcon,
  'griddy-eye-off-line': 'griddy-eye-off-line' as sbnbIcon,
  'griddy-globe': 'griddy-globe' as sbnbIcon,
  'griddy-hands-support': 'griddy-hands-support' as sbnbIcon,
  'griddy-heart': 'griddy-heart' as sbnbIcon,
  'griddy-help-circle': 'griddy-help-circle' as sbnbIcon,
  'griddy-home': 'griddy-home' as sbnbIcon,
  'griddy-hotel': 'griddy-hotel' as sbnbIcon,
  'griddy-image': 'griddy-image' as sbnbIcon,
  'griddy-info-circle': 'griddy-info-circle' as sbnbIcon,
  'griddy-invoice': 'griddy-invoice' as sbnbIcon,
  'griddy-iot': 'griddy-iot' as sbnbIcon,
  'griddy-key': 'griddy-key' as sbnbIcon,
  'griddy-laptop': 'griddy-laptop' as sbnbIcon,
  'griddy-layers-line': 'griddy-layers-line' as sbnbIcon,
  'griddy-layers-two-line': 'griddy-layers-two-line' as sbnbIcon,
  'griddy-license-draft': 'griddy-license-draft' as sbnbIcon,
  'griddy-license': 'griddy-license' as sbnbIcon,
  'griddy-lightbulb-off': 'griddy-lightbulb-off' as sbnbIcon,
  'griddy-lightbulb-on': 'griddy-lightbulb-on' as sbnbIcon,
  'griddy-link-external': 'griddy-link-external' as sbnbIcon,
  'griddy-link': 'griddy-link' as sbnbIcon,
  'griddy-location-pin': 'griddy-location-pin' as sbnbIcon,
  'griddy-lock-open': 'griddy-lock-open' as sbnbIcon,
  'griddy-lock': 'griddy-lock' as sbnbIcon,
  'griddy-magic-wand': 'griddy-magic-wand' as sbnbIcon,
  'griddy-meet-and-greet': 'griddy-meet-and-greet' as sbnbIcon,
  'griddy-menu': 'griddy-menu' as sbnbIcon,
  'griddy-microphone-off': 'griddy-microphone-off' as sbnbIcon,
  'griddy-microphone': 'griddy-microphone' as sbnbIcon,
  'griddy-minus-circle': 'griddy-minus-circle' as sbnbIcon,
  'griddy-minus': 'griddy-minus' as sbnbIcon,
  'griddy-moon-alt-calendar': 'griddy-moon-alt-calendar' as sbnbIcon,
  'griddy-moon-alt': 'griddy-moon-alt' as sbnbIcon,
  'griddy-more-horizontal': 'griddy-more-horizontal' as sbnbIcon,
  'griddy-notification': 'griddy-notification' as sbnbIcon,
  'griddy-openai': 'griddy-openai' as sbnbIcon,
  'griddy-paint-brush': 'griddy-paint-brush' as sbnbIcon,
  'griddy-pet-friendly': 'griddy-pet-friendly' as sbnbIcon,
  'griddy-play-circle': 'griddy-play-circle' as sbnbIcon,
  'griddy-play': 'griddy-play' as sbnbIcon,
  'griddy-plus-circle': 'griddy-plus-circle' as sbnbIcon,
  'griddy-plus': 'griddy-plus' as sbnbIcon,
  'griddy-refresh': 'griddy-refresh' as sbnbIcon,
  'griddy-search-check': 'griddy-search-check' as sbnbIcon,
  'griddy-search': 'griddy-search' as sbnbIcon,
  'griddy-settings': 'griddy-settings' as sbnbIcon,
  'griddy-shield-check': 'griddy-shield-check' as sbnbIcon,
  'griddy-shield-person': 'griddy-shield-person' as sbnbIcon,
  'griddy-sparks': 'griddy-sparks' as sbnbIcon,
  'griddy-star': 'griddy-star' as sbnbIcon,
  'griddy-sticky-note': 'griddy-sticky-note' as sbnbIcon,
  'griddy-store': 'griddy-store' as sbnbIcon,
  'griddy-sync': 'griddy-sync' as sbnbIcon,
  'griddy-tag': 'griddy-tag' as sbnbIcon,
  'griddy-temperature': 'griddy-temperature' as sbnbIcon,
  'griddy-thermometer': 'griddy-thermometer' as sbnbIcon,
  'griddy-thumbs-down': 'griddy-thumbs-down' as sbnbIcon,
  'griddy-thumbs-up': 'griddy-thumbs-up' as sbnbIcon,
  'griddy-time-back': 'griddy-time-back' as sbnbIcon,
  'griddy-translate': 'griddy-translate' as sbnbIcon,
  'griddy-trash-alt': 'griddy-trash-alt' as sbnbIcon,
  'griddy-trend-up': 'griddy-trend-up' as sbnbIcon,
  'griddy-unfold-less': 'griddy-unfold-less' as sbnbIcon,
  'griddy-unfold-more': 'griddy-unfold-more' as sbnbIcon,
  'griddy-upload-circle': 'griddy-upload-circle' as sbnbIcon,
  'griddy-user-circle': 'griddy-user-circle' as sbnbIcon,
  'griddy-user': 'griddy-user' as sbnbIcon,
  'griddy-users-event': 'griddy-users-event' as sbnbIcon,
  'griddy-wallet-line': 'griddy-wallet-line' as sbnbIcon,
  'griddy-wifi': 'griddy-wifi' as sbnbIcon,
};
export interface SbnbIcon {
  name: sbnbIcon;
  data: string;
}
export type SbnbIconNameSubset<T extends Readonly<SbnbIcon[]>> = T[number]['name'];
export const sbnbGriddyIcons = [
  iconGriddyAlertCircle,
  iconGriddyAlertTriangle,
  iconGriddyAnalyzeVoice,
  iconGriddyAnnouncementAlt02,
  iconGriddyArrowElbowDownRight,
  iconGriddyArrowLeft,
  iconGriddyArrowRight,
  iconGriddyArrowUp,
  iconGriddyAttachmentAlt01,
  iconGriddyAttachment,
  iconGriddyBookOpen,
  iconGriddyBook,
  iconGriddyBriefcaseAlt,
  iconGriddyCalendarCheck,
  iconGriddyCalendarDate,
  iconGriddyCalendarTime,
  iconGriddyCalendar,
  iconGriddyChartLineData,
  iconGriddyChartLineSmooth,
  iconGriddyChatBubbleText,
  iconGriddyCheckCircleAlt01,
  iconGriddyCheckCircle,
  iconGriddyCheck,
  iconGriddyCheckbox,
  iconGriddyChevronDown,
  iconGriddyChevronLeft,
  iconGriddyChevronRight,
  iconGriddyChevronUp,
  iconGriddyCircleDashed,
  iconGriddyClipboardList,
  iconGriddyCloseCircle,
  iconGriddyClose,
  iconGriddyCode,
  iconGriddyConsole,
  iconGriddyCopy,
  iconGriddyCreditCard,
  iconGriddyCurrencyExchange,
  iconGriddyCurrency,
  iconGriddyCursorArrow,
  iconGriddyCursorClick,
  iconGriddyDatabaseLine,
  iconGriddyDownload,
  iconGriddyDragIndicator,
  iconGriddyEdit,
  iconGriddyEmailForward,
  iconGriddyEmailRead,
  iconGriddyEmail,
  iconGriddyEyeLine,
  iconGriddyEyeOffLine,
  iconGriddyGlobe,
  iconGriddyHandsSupport,
  iconGriddyHeart,
  iconGriddyHelpCircle,
  iconGriddyHome,
  iconGriddyHotel,
  iconGriddyImage,
  iconGriddyInfoCircle,
  iconGriddyInvoice,
  iconGriddyIot,
  iconGriddyKey,
  iconGriddyLaptop,
  iconGriddyLayersLine,
  iconGriddyLayersTwoLine,
  iconGriddyLicenseDraft,
  iconGriddyLicense,
  iconGriddyLightbulbOff,
  iconGriddyLightbulbOn,
  iconGriddyLinkExternal,
  iconGriddyLink,
  iconGriddyLocationPin,
  iconGriddyLockOpen,
  iconGriddyLock,
  iconGriddyMagicWand,
  iconGriddyMeetAndGreet,
  iconGriddyMenu,
  iconGriddyMicrophoneOff,
  iconGriddyMicrophone,
  iconGriddyMinusCircle,
  iconGriddyMinus,
  iconGriddyMoonAltCalendar,
  iconGriddyMoonAlt,
  iconGriddyMoreHorizontal,
  iconGriddyNotification,
  iconGriddyOpenai,
  iconGriddyPaintBrush,
  iconGriddyPetFriendly,
  iconGriddyPlayCircle,
  iconGriddyPlay,
  iconGriddyPlusCircle,
  iconGriddyPlus,
  iconGriddyRefresh,
  iconGriddySearchCheck,
  iconGriddySearch,
  iconGriddySettings,
  iconGriddyShieldCheck,
  iconGriddyShieldPerson,
  iconGriddySparks,
  iconGriddyStar,
  iconGriddyStickyNote,
  iconGriddyStore,
  iconGriddySync,
  iconGriddyTag,
  iconGriddyTemperature,
  iconGriddyThermometer,
  iconGriddyThumbsDown,
  iconGriddyThumbsUp,
  iconGriddyTimeBack,
  iconGriddyTranslate,
  iconGriddyTrashAlt,
  iconGriddyTrendUp,
  iconGriddyUnfoldLess,
  iconGriddyUnfoldMore,
  iconGriddyUploadCircle,
  iconGriddyUserCircle,
  iconGriddyUser,
  iconGriddyUsersEvent,
  iconGriddyWalletLine,
  iconGriddyWifi,
];
